{
  "1000": {
    "code": "1000",
    "scope": "classic",
    "color": {
      "hex": "#CDBA88",
      "websafe": "#cccc99",
      "rgb": {
        "r": 205,
        "g": 186,
        "b": 136
      },
      "hsl": {
        "h": 43,
        "s": 41,
        "l": 67
      },
      "hsb": {
        "h": 43,
        "s": 34,
        "b": 80
      },
      "cmyk": {
        "c": "5",
        "m": "10",
        "y": "40",
        "k": "10"
      }
    },
    "names": {
      "en": "Green beige"
    }
  },
  "1001": {
    "code": "1001",
    "scope": "classic",
    "color": {
      "hex": "#D0B084",
      "websafe": "#cc9999",
      "rgb": {
        "r": 208,
        "g": 176,
        "b": 132
      },
      "hsl": {
        "h": 35,
        "s": 45,
        "l": 67
      },
      "hsb": {
        "h": 35,
        "s": 37,
        "b": 82
      },
      "cmyk": {
        "c": "5",
        "m": "20",
        "y": "40",
        "k": "10"
      }
    },
    "names": {
      "en": "Beige"
    }
  },
  "1002": {
    "code": "1002",
    "scope": "classic",
    "color": {
      "hex": "#D2AA6D",
      "websafe": "#cc9966",
      "rgb": {
        "r": 210,
        "g": 170,
        "b": 109
      },
      "hsl": {
        "h": 36,
        "s": 53,
        "l": 63
      },
      "hsb": {
        "h": 36,
        "s": 48,
        "b": 82
      },
      "cmyk": {
        "c": "5",
        "m": "20",
        "y": "50",
        "k": "10"
      }
    },
    "names": {
      "en": "Sand yellow"
    }
  },
  "1003": {
    "code": "1003",
    "scope": "classic",
    "color": {
      "hex": "#F9A800",
      "websafe": "#ff9900",
      "rgb": {
        "r": 249,
        "g": 168,
        "b": 0
      },
      "hsl": {
        "h": 40,
        "s": 100,
        "l": 49
      },
      "hsb": {
        "h": 40,
        "s": 100,
        "b": 98
      },
      "cmyk": {
        "c": "0",
        "m": "35",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Signal yellow"
    }
  },
  "1004": {
    "code": "1004",
    "scope": "classic",
    "color": {
      "hex": "#E49E00",
      "websafe": "#cc9900",
      "rgb": {
        "r": 228,
        "g": 158,
        "b": 0
      },
      "hsl": {
        "h": 42,
        "s": 100,
        "l": 45
      },
      "hsb": {
        "h": 42,
        "s": 100,
        "b": 89
      },
      "cmyk": {
        "c": "10",
        "m": "35",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Golden yellow"
    }
  },
  "1005": {
    "code": "1005",
    "scope": "classic",
    "color": {
      "hex": "#CB8E00",
      "websafe": "#cc9900",
      "rgb": {
        "r": 203,
        "g": 142,
        "b": 0
      },
      "hsl": {
        "h": 42,
        "s": 100,
        "l": 40
      },
      "hsb": {
        "h": 42,
        "s": 100,
        "b": 80
      },
      "cmyk": {
        "c": "0",
        "m": "30",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Honey yellow"
    }
  },
  "1006": {
    "code": "1006",
    "scope": "classic",
    "color": {
      "hex": "#E29000",
      "websafe": "#cc9900",
      "rgb": {
        "r": 226,
        "g": 144,
        "b": 0
      },
      "hsl": {
        "h": 38,
        "s": 100,
        "l": 44
      },
      "hsb": {
        "h": 38,
        "s": 100,
        "b": 89
      },
      "cmyk": {
        "c": "0",
        "m": "40",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Maize yellow"
    }
  },
  "1007": {
    "code": "1007",
    "scope": "classic",
    "color": {
      "hex": "#E88C00",
      "websafe": "#ff9900",
      "rgb": {
        "r": 232,
        "g": 140,
        "b": 0
      },
      "hsl": {
        "h": 36,
        "s": 100,
        "l": 45
      },
      "hsb": {
        "h": 36,
        "s": 100,
        "b": 91
      },
      "cmyk": {
        "c": "0",
        "m": "50",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Daffodil yellow"
    }
  },
  "1011": {
    "code": "1011",
    "scope": "classic",
    "color": {
      "hex": "#AF804F",
      "websafe": "#999966",
      "rgb": {
        "r": 175,
        "g": 128,
        "b": 79
      },
      "hsl": {
        "h": 31,
        "s": 38,
        "l": 50
      },
      "hsb": {
        "h": 31,
        "s": 55,
        "b": 69
      },
      "cmyk": {
        "c": "20",
        "m": "40",
        "y": "60",
        "k": "0"
      }
    },
    "names": {
      "en": "Brown beige"
    }
  },
  "1012": {
    "code": "1012",
    "scope": "classic",
    "color": {
      "hex": "#DDAF27",
      "websafe": "#cc9933",
      "rgb": {
        "r": 221,
        "g": 175,
        "b": 39
      },
      "hsl": {
        "h": 45,
        "s": 73,
        "l": 51
      },
      "hsb": {
        "h": 45,
        "s": 82,
        "b": 87
      },
      "cmyk": {
        "c": "5",
        "m": "20",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Lemon yellow"
    }
  },
  "1013": {
    "code": "1013",
    "scope": "classic",
    "color": {
      "hex": "#E3D9C6",
      "websafe": "#cccccc",
      "rgb": {
        "r": 227,
        "g": 217,
        "b": 198
      },
      "hsl": {
        "h": 39,
        "s": 34,
        "l": 83
      },
      "hsb": {
        "h": 39,
        "s": 13,
        "b": 89
      },
      "cmyk": {
        "c": "5",
        "m": "10",
        "y": "20",
        "k": "0"
      }
    },
    "names": {
      "en": "Oyster white"
    }
  },
  "1014": {
    "code": "1014",
    "scope": "classic",
    "color": {
      "hex": "#DDC49A",
      "websafe": "#cccc99",
      "rgb": {
        "r": 221,
        "g": 196,
        "b": 154
      },
      "hsl": {
        "h": 38,
        "s": 50,
        "l": 74
      },
      "hsb": {
        "h": 38,
        "s": 30,
        "b": 87
      },
      "cmyk": {
        "c": "5",
        "m": "20",
        "y": "50",
        "k": "0"
      }
    },
    "names": {
      "en": "Ivory"
    }
  },
  "1015": {
    "code": "1015",
    "scope": "classic",
    "color": {
      "hex": "#E6D2B5",
      "websafe": "#ffcccc",
      "rgb": {
        "r": 230,
        "g": 210,
        "b": 181
      },
      "hsl": {
        "h": 36,
        "s": 49,
        "l": 81
      },
      "hsb": {
        "h": 36,
        "s": 21,
        "b": 90
      },
      "cmyk": {
        "c": "5",
        "m": "10",
        "y": "30",
        "k": "0"
      }
    },
    "names": {
      "en": "Light ivory"
    }
  },
  "1016": {
    "code": "1016",
    "scope": "classic",
    "color": {
      "hex": "#F1DD38",
      "websafe": "#ffcc33",
      "rgb": {
        "r": 241,
        "g": 221,
        "b": 56
      },
      "hsl": {
        "h": 54,
        "s": 87,
        "l": 58
      },
      "hsb": {
        "h": 54,
        "s": 77,
        "b": 95
      },
      "cmyk": {
        "c": "5",
        "m": "0",
        "y": "90",
        "k": "0"
      }
    },
    "names": {
      "en": "Sulfur yellow"
    }
  },
  "1017": {
    "code": "1017",
    "scope": "classic",
    "color": {
      "hex": "#F6A950",
      "websafe": "#ff9966",
      "rgb": {
        "r": 246,
        "g": 169,
        "b": 80
      },
      "hsl": {
        "h": 32,
        "s": 90,
        "l": 64
      },
      "hsb": {
        "h": 32,
        "s": 67,
        "b": 96
      },
      "cmyk": {
        "c": "0",
        "m": "40",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Saffron yellow"
    }
  },
  "1018": {
    "code": "1018",
    "scope": "classic",
    "color": {
      "hex": "#FACA30",
      "websafe": "#ffcc33",
      "rgb": {
        "r": 250,
        "g": 202,
        "b": 48
      },
      "hsl": {
        "h": 46,
        "s": 95,
        "l": 58
      },
      "hsb": {
        "h": 46,
        "s": 81,
        "b": 98
      },
      "cmyk": {
        "c": "0",
        "m": "15",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Zinc yellow"
    }
  },
  "1019": {
    "code": "1019",
    "scope": "classic",
    "color": {
      "hex": "#A48F7A",
      "websafe": "#999966",
      "rgb": {
        "r": 164,
        "g": 143,
        "b": 122
      },
      "hsl": {
        "h": 30,
        "s": 19,
        "l": 56
      },
      "hsb": {
        "h": 30,
        "s": 26,
        "b": 64
      },
      "cmyk": {
        "c": "0",
        "m": "15",
        "y": "40",
        "k": "45"
      }
    },
    "names": {
      "en": "Grey beige"
    }
  },
  "1020": {
    "code": "1020",
    "scope": "classic",
    "color": {
      "hex": "#A08F65",
      "websafe": "#999966",
      "rgb": {
        "r": 160,
        "g": 143,
        "b": 101
      },
      "hsl": {
        "h": 43,
        "s": 24,
        "l": 51
      },
      "hsb": {
        "h": 43,
        "s": 37,
        "b": 63
      },
      "cmyk": {
        "c": "30",
        "m": "25",
        "y": "60",
        "k": "20"
      }
    },
    "names": {
      "en": "Olive yellow"
    }
  },
  "1021": {
    "code": "1021",
    "scope": "classic",
    "color": {
      "hex": "#F6B600",
      "websafe": "#ffcc00",
      "rgb": {
        "r": 246,
        "g": 182,
        "b": 0
      },
      "hsl": {
        "h": 44,
        "s": 100,
        "l": 48
      },
      "hsb": {
        "h": 44,
        "s": 100,
        "b": 96
      },
      "cmyk": {
        "c": "0",
        "m": "5",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Colza yellow"
    }
  },
  "1023": {
    "code": "1023",
    "scope": "classic",
    "color": {
      "hex": "#F7B500",
      "websafe": "#ffcc00",
      "rgb": {
        "r": 247,
        "g": 181,
        "b": 0
      },
      "hsl": {
        "h": 44,
        "s": 100,
        "l": 48
      },
      "hsb": {
        "h": 44,
        "s": 100,
        "b": 97
      },
      "cmyk": {
        "c": "0",
        "m": "25",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Traffic yellow"
    }
  },
  "1024": {
    "code": "1024",
    "scope": "classic",
    "color": {
      "hex": "#BA8F4C",
      "websafe": "#cc9933",
      "rgb": {
        "r": 186,
        "g": 143,
        "b": 76
      },
      "hsl": {
        "h": 37,
        "s": 44,
        "l": 51
      },
      "hsb": {
        "h": 37,
        "s": 59,
        "b": 73
      },
      "cmyk": {
        "c": "5",
        "m": "30",
        "y": "80",
        "k": "30"
      }
    },
    "names": {
      "en": "Ochre yellow"
    }
  },
  "1026": {
    "code": "1026",
    "scope": "classic",
    "color": {
      "hex": "#FFFF00",
      "websafe": "#ffff00",
      "rgb": {
        "r": 255,
        "g": 255,
        "b": 0
      },
      "hsl": {
        "h": 60,
        "s": 100,
        "l": 50
      },
      "hsb": {
        "h": 60,
        "s": 100,
        "b": 100
      },
      "cmyk": {
        "c": "5",
        "m": "0",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Luminous yellow"
    }
  },
  "1027": {
    "code": "1027",
    "scope": "classic",
    "color": {
      "hex": "#A77F0E",
      "websafe": "#996600",
      "rgb": {
        "r": 167,
        "g": 127,
        "b": 14
      },
      "hsl": {
        "h": 44,
        "s": 85,
        "l": 35
      },
      "hsb": {
        "h": 44,
        "s": 92,
        "b": 65
      },
      "cmyk": {
        "c": "5",
        "m": "10",
        "y": "100",
        "k": "40"
      }
    },
    "names": {
      "en": "Curry"
    }
  },
  "1028": {
    "code": "1028",
    "scope": "classic",
    "color": {
      "hex": "#FF9B00",
      "websafe": "#ff9900",
      "rgb": {
        "r": 255,
        "g": 155,
        "b": 0
      },
      "hsl": {
        "h": 36,
        "s": 100,
        "l": 50
      },
      "hsb": {
        "h": 36,
        "s": 100,
        "b": 100
      },
      "cmyk": {
        "c": "0",
        "m": "40",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Melon yellow"
    }
  },
  "1032": {
    "code": "1032",
    "scope": "classic",
    "color": {
      "hex": "#E2A300",
      "websafe": "#cc9900",
      "rgb": {
        "r": 226,
        "g": 163,
        "b": 0
      },
      "hsl": {
        "h": 43,
        "s": 100,
        "l": 44
      },
      "hsb": {
        "h": 43,
        "s": 100,
        "b": 89
      },
      "cmyk": {
        "c": "15",
        "m": "40",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Broom yellow"
    }
  },
  "1033": {
    "code": "1033",
    "scope": "classic",
    "color": {
      "hex": "#F99A1C",
      "websafe": "#ff9933",
      "rgb": {
        "r": 249,
        "g": 154,
        "b": 28
      },
      "hsl": {
        "h": 34,
        "s": 95,
        "l": 54
      },
      "hsb": {
        "h": 34,
        "s": 89,
        "b": 98
      },
      "cmyk": {
        "c": "0",
        "m": "50",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Dahlia yellow"
    }
  },
  "1034": {
    "code": "1034",
    "scope": "classic",
    "color": {
      "hex": "#EB9C52",
      "websafe": "#ff9966",
      "rgb": {
        "r": 235,
        "g": 156,
        "b": 82
      },
      "hsl": {
        "h": 29,
        "s": 79,
        "l": 62
      },
      "hsb": {
        "h": 29,
        "s": 65,
        "b": 92
      },
      "cmyk": {
        "c": "0",
        "m": "45",
        "y": "70",
        "k": "0"
      }
    },
    "names": {
      "en": "Pastel yellow"
    }
  },
  "1035": {
    "code": "1035",
    "scope": "classic",
    "color": {
      "hex": "#908370",
      "websafe": "#999966",
      "rgb": {
        "r": 144,
        "g": 131,
        "b": 112
      },
      "hsl": {
        "h": 36,
        "s": 13,
        "l": 50
      },
      "hsb": {
        "h": 36,
        "s": 22,
        "b": 56
      },
      "cmyk": {
        "c": "10",
        "m": "25",
        "y": "40",
        "k": "40"
      }
    },
    "names": {
      "en": "Pearl beige"
    }
  },
  "1036": {
    "code": "1036",
    "scope": "classic",
    "color": {
      "hex": "#80643F",
      "websafe": "#996633",
      "rgb": {
        "r": 128,
        "g": 100,
        "b": 63
      },
      "hsl": {
        "h": 34,
        "s": 34,
        "l": 37
      },
      "hsb": {
        "h": 34,
        "s": 51,
        "b": 50
      },
      "cmyk": {
        "c": "30",
        "m": "30",
        "y": "50",
        "k": "70"
      }
    },
    "names": {
      "en": "Pearl gold"
    }
  },
  "1037": {
    "code": "1037",
    "scope": "classic",
    "color": {
      "hex": "#F09200",
      "websafe": "#ff9900",
      "rgb": {
        "r": 240,
        "g": 146,
        "b": 0
      },
      "hsl": {
        "h": 37,
        "s": 100,
        "l": 47
      },
      "hsb": {
        "h": 37,
        "s": 100,
        "b": 94
      },
      "cmyk": {
        "c": "0",
        "m": "45",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Sun yellow"
    }
  },
  "2000": {
    "code": "2000",
    "scope": "classic",
    "color": {
      "hex": "#DA6E00",
      "websafe": "#cc6600",
      "rgb": {
        "r": 218,
        "g": 110,
        "b": 0
      },
      "hsl": {
        "h": 30,
        "s": 100,
        "l": 43
      },
      "hsb": {
        "h": 30,
        "s": 100,
        "b": 85
      },
      "cmyk": {
        "c": "0",
        "m": "65",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Yellow orange"
    }
  },
  "2001": {
    "code": "2001",
    "scope": "classic",
    "color": {
      "hex": "#BA481B",
      "websafe": "#cc3333",
      "rgb": {
        "r": 186,
        "g": 72,
        "b": 27
      },
      "hsl": {
        "h": 17,
        "s": 75,
        "l": 42
      },
      "hsb": {
        "h": 17,
        "s": 85,
        "b": 73
      },
      "cmyk": {
        "c": "10",
        "m": "85",
        "y": "100",
        "k": "10"
      }
    },
    "names": {
      "en": "Red orange"
    }
  },
  "2002": {
    "code": "2002",
    "scope": "classic",
    "color": {
      "hex": "#BF3922",
      "websafe": "#cc3333",
      "rgb": {
        "r": 191,
        "g": 57,
        "b": 34
      },
      "hsl": {
        "h": 9,
        "s": 70,
        "l": 44
      },
      "hsb": {
        "h": 9,
        "s": 82,
        "b": 75
      },
      "cmyk": {
        "c": "0",
        "m": "90",
        "y": "100",
        "k": "10"
      }
    },
    "names": {
      "en": "Vermilion"
    }
  },
  "2003": {
    "code": "2003",
    "scope": "classic",
    "color": {
      "hex": "#F67828",
      "websafe": "#ff6633",
      "rgb": {
        "r": 246,
        "g": 120,
        "b": 40
      },
      "hsl": {
        "h": 23,
        "s": 92,
        "l": 56
      },
      "hsb": {
        "h": 23,
        "s": 84,
        "b": 96
      },
      "cmyk": {
        "c": "0",
        "m": "70",
        "y": "90",
        "k": "0"
      }
    },
    "names": {
      "en": "Pastel orange"
    }
  },
  "2004": {
    "code": "2004",
    "scope": "classic",
    "color": {
      "hex": "#E25303",
      "websafe": "#cc6600",
      "rgb": {
        "r": 226,
        "g": 83,
        "b": 3
      },
      "hsl": {
        "h": 22,
        "s": 97,
        "l": 45
      },
      "hsb": {
        "h": 22,
        "s": 99,
        "b": 89
      },
      "cmyk": {
        "c": "0",
        "m": "75",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Pure orange"
    }
  },
  "2005": {
    "code": "2005",
    "scope": "classic",
    "color": {
      "hex": "#FF4D06",
      "websafe": "#ff6600",
      "rgb": {
        "r": 255,
        "g": 77,
        "b": 6
      },
      "hsl": {
        "h": 17,
        "s": 100,
        "l": 51
      },
      "hsb": {
        "h": 17,
        "s": 98,
        "b": 100
      },
      "cmyk": {
        "c": "0",
        "m": "70",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Luminous orange"
    }
  },
  "2007": {
    "code": "2007",
    "scope": "classic",
    "color": {
      "hex": "#FFB200",
      "websafe": "#ff9900",
      "rgb": {
        "r": 255,
        "g": 178,
        "b": 0
      },
      "hsl": {
        "h": 42,
        "s": 100,
        "l": 50
      },
      "hsb": {
        "h": 42,
        "s": 100,
        "b": 100
      },
      "cmyk": {
        "c": "0",
        "m": "45",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Luminous bright orange"
    }
  },
  "2008": {
    "code": "2008",
    "scope": "classic",
    "color": {
      "hex": "#ED6B21",
      "websafe": "#ff6633",
      "rgb": {
        "r": 237,
        "g": 107,
        "b": 33
      },
      "hsl": {
        "h": 22,
        "s": 85,
        "l": 53
      },
      "hsb": {
        "h": 22,
        "s": 86,
        "b": 93
      },
      "cmyk": {
        "c": "0",
        "m": "65",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Bright red orange"
    }
  },
  "2009": {
    "code": "2009",
    "scope": "classic",
    "color": {
      "hex": "#DE5307",
      "websafe": "#cc6600",
      "rgb": {
        "r": 222,
        "g": 83,
        "b": 7
      },
      "hsl": {
        "h": 21,
        "s": 94,
        "l": 45
      },
      "hsb": {
        "h": 21,
        "s": 97,
        "b": 87
      },
      "cmyk": {
        "c": "0",
        "m": "80",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Traffic orange"
    }
  },
  "2010": {
    "code": "2010",
    "scope": "classic",
    "color": {
      "hex": "#D05D28",
      "websafe": "#cc6633",
      "rgb": {
        "r": 208,
        "g": 93,
        "b": 40
      },
      "hsl": {
        "h": 19,
        "s": 68,
        "l": 49
      },
      "hsb": {
        "h": 19,
        "s": 81,
        "b": 82
      },
      "cmyk": {
        "c": "0",
        "m": "80",
        "y": "100",
        "k": "10"
      }
    },
    "names": {
      "en": "Signal orange"
    }
  },
  "2011": {
    "code": "2011",
    "scope": "classic",
    "color": {
      "hex": "#E26E0E",
      "websafe": "#cc6600",
      "rgb": {
        "r": 226,
        "g": 110,
        "b": 14
      },
      "hsl": {
        "h": 27,
        "s": 88,
        "l": 47
      },
      "hsb": {
        "h": 27,
        "s": 94,
        "b": 89
      },
      "cmyk": {
        "c": "0",
        "m": "65",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Deep orange"
    }
  },
  "2012": {
    "code": "2012",
    "scope": "classic",
    "color": {
      "hex": "#D5654D",
      "websafe": "#cc6666",
      "rgb": {
        "r": 213,
        "g": 101,
        "b": 77
      },
      "hsl": {
        "h": 11,
        "s": 62,
        "l": 57
      },
      "hsb": {
        "h": 11,
        "s": 64,
        "b": 84
      },
      "cmyk": {
        "c": "10",
        "m": "80",
        "y": "70",
        "k": "0"
      }
    },
    "names": {
      "en": "Salmon orange"
    }
  },
  "2013": {
    "code": "2013",
    "scope": "classic",
    "color": {
      "hex": "#923E25",
      "websafe": "#993333",
      "rgb": {
        "r": 146,
        "g": 62,
        "b": 37
      },
      "hsl": {
        "h": 14,
        "s": 60,
        "l": 36
      },
      "hsb": {
        "h": 14,
        "s": 75,
        "b": 57
      },
      "cmyk": {
        "c": "20",
        "m": "90",
        "y": "100",
        "k": "30"
      }
    },
    "names": {
      "en": "Pearl orange"
    }
  },
  "3000": {
    "code": "3000",
    "scope": "classic",
    "color": {
      "hex": "#A72920",
      "websafe": "#993333",
      "rgb": {
        "r": 167,
        "g": 41,
        "b": 32
      },
      "hsl": {
        "h": 4,
        "s": 68,
        "l": 39
      },
      "hsb": {
        "h": 4,
        "s": 81,
        "b": 65
      },
      "cmyk": {
        "c": "10",
        "m": "100",
        "y": "100",
        "k": "20"
      }
    },
    "names": {
      "en": "Flame red"
    }
  },
  "3001": {
    "code": "3001",
    "scope": "classic",
    "color": {
      "hex": "#9B2423",
      "websafe": "#993333",
      "rgb": {
        "r": 155,
        "g": 36,
        "b": 35
      },
      "hsl": {
        "h": 0,
        "s": 63,
        "l": 37
      },
      "hsb": {
        "h": 0,
        "s": 77,
        "b": 61
      },
      "cmyk": {
        "c": "20",
        "m": "100",
        "y": "100",
        "k": "10"
      }
    },
    "names": {
      "en": "Signal red"
    }
  },
  "3002": {
    "code": "3002",
    "scope": "classic",
    "color": {
      "hex": "#9B2321",
      "websafe": "#993333",
      "rgb": {
        "r": 155,
        "g": 35,
        "b": 33
      },
      "hsl": {
        "h": 1,
        "s": 65,
        "l": 37
      },
      "hsb": {
        "h": 1,
        "s": 79,
        "b": 61
      },
      "cmyk": {
        "c": "10",
        "m": "100",
        "y": "100",
        "k": "25"
      }
    },
    "names": {
      "en": "Carmine red"
    }
  },
  "3003": {
    "code": "3003",
    "scope": "classic",
    "color": {
      "hex": "#861A22",
      "websafe": "#993333",
      "rgb": {
        "r": 134,
        "g": 26,
        "b": 34
      },
      "hsl": {
        "h": 356,
        "s": 68,
        "l": 31
      },
      "hsb": {
        "h": 356,
        "s": 81,
        "b": 53
      },
      "cmyk": {
        "c": "30",
        "m": "100",
        "y": "80",
        "k": "20"
      }
    },
    "names": {
      "en": "Ruby red"
    }
  },
  "3004": {
    "code": "3004",
    "scope": "classic",
    "color": {
      "hex": "#6B1C23",
      "websafe": "#663333",
      "rgb": {
        "r": 107,
        "g": 28,
        "b": 35
      },
      "hsl": {
        "h": 355,
        "s": 59,
        "l": 26
      },
      "hsb": {
        "h": 355,
        "s": 74,
        "b": 42
      },
      "cmyk": {
        "c": "30",
        "m": "100",
        "y": "70",
        "k": "40"
      }
    },
    "names": {
      "en": "Purple red"
    }
  },
  "3005": {
    "code": "3005",
    "scope": "classic",
    "color": {
      "hex": "#59191F",
      "websafe": "#660033",
      "rgb": {
        "r": 89,
        "g": 25,
        "b": 31
      },
      "hsl": {
        "h": 354,
        "s": 56,
        "l": 22
      },
      "hsb": {
        "h": 354,
        "s": 72,
        "b": 35
      },
      "cmyk": {
        "c": "40",
        "m": "100",
        "y": "60",
        "k": "40"
      }
    },
    "names": {
      "en": "Wine red"
    }
  },
  "3007": {
    "code": "3007",
    "scope": "classic",
    "color": {
      "hex": "#3E2022",
      "websafe": "#333333",
      "rgb": {
        "r": 62,
        "g": 32,
        "b": 34
      },
      "hsl": {
        "h": 356,
        "s": 32,
        "l": 18
      },
      "hsb": {
        "h": 356,
        "s": 48,
        "b": 24
      },
      "cmyk": {
        "c": "50",
        "m": "100",
        "y": "40",
        "k": "50"
      }
    },
    "names": {
      "en": "Black red"
    }
  },
  "3009": {
    "code": "3009",
    "scope": "classic",
    "color": {
      "hex": "#6D342D",
      "websafe": "#663333",
      "rgb": {
        "r": 109,
        "g": 52,
        "b": 45
      },
      "hsl": {
        "h": 7,
        "s": 42,
        "l": 30
      },
      "hsb": {
        "h": 7,
        "s": 59,
        "b": 43
      },
      "cmyk": {
        "c": "40",
        "m": "100",
        "y": "100",
        "k": "30"
      }
    },
    "names": {
      "en": "Oxide red"
    }
  },
  "3011": {
    "code": "3011",
    "scope": "classic",
    "color": {
      "hex": "#792423",
      "websafe": "#663333",
      "rgb": {
        "r": 121,
        "g": 36,
        "b": 35
      },
      "hsl": {
        "h": 1,
        "s": 55,
        "l": 31
      },
      "hsb": {
        "h": 1,
        "s": 71,
        "b": 47
      },
      "cmyk": {
        "c": "20",
        "m": "100",
        "y": "80",
        "k": "40"
      }
    },
    "names": {
      "en": "Brown red"
    }
  },
  "3012": {
    "code": "3012",
    "scope": "classic",
    "color": {
      "hex": "#C6846D",
      "websafe": "#cc9966",
      "rgb": {
        "r": 198,
        "g": 132,
        "b": 109
      },
      "hsl": {
        "h": 16,
        "s": 44,
        "l": 60
      },
      "hsb": {
        "h": 16,
        "s": 45,
        "b": 78
      },
      "cmyk": {
        "c": "0",
        "m": "50",
        "y": "50",
        "k": "20"
      }
    },
    "names": {
      "en": "Beige red"
    }
  },
  "3013": {
    "code": "3013",
    "scope": "classic",
    "color": {
      "hex": "#972E25",
      "websafe": "#993333",
      "rgb": {
        "r": 151,
        "g": 46,
        "b": 37
      },
      "hsl": {
        "h": 5,
        "s": 61,
        "l": 37
      },
      "hsb": {
        "h": 5,
        "s": 75,
        "b": 59
      },
      "cmyk": {
        "c": "0",
        "m": "100",
        "y": "90",
        "k": "30"
      }
    },
    "names": {
      "en": "Tomato red"
    }
  },
  "3014": {
    "code": "3014",
    "scope": "classic",
    "color": {
      "hex": "#CB7375",
      "websafe": "#cc6666",
      "rgb": {
        "r": 203,
        "g": 115,
        "b": 117
      },
      "hsl": {
        "h": 359,
        "s": 46,
        "l": 62
      },
      "hsb": {
        "h": 359,
        "s": 43,
        "b": 80
      },
      "cmyk": {
        "c": "0",
        "m": "65",
        "y": "40",
        "k": "10"
      }
    },
    "names": {
      "en": "Antique pink"
    }
  },
  "3015": {
    "code": "3015",
    "scope": "classic",
    "color": {
      "hex": "#D8A0A6",
      "websafe": "#cc9999",
      "rgb": {
        "r": 216,
        "g": 160,
        "b": 166
      },
      "hsl": {
        "h": 354,
        "s": 42,
        "l": 74
      },
      "hsb": {
        "h": 354,
        "s": 26,
        "b": 85
      },
      "cmyk": {
        "c": "5",
        "m": "40",
        "y": "20",
        "k": "0"
      }
    },
    "names": {
      "en": "Light pink"
    }
  },
  "3016": {
    "code": "3016",
    "scope": "classic",
    "color": {
      "hex": "#A63D2F",
      "websafe": "#993333",
      "rgb": {
        "r": 166,
        "g": 61,
        "b": 47
      },
      "hsl": {
        "h": 7,
        "s": 56,
        "l": 42
      },
      "hsb": {
        "h": 7,
        "s": 72,
        "b": 65
      },
      "cmyk": {
        "c": "0",
        "m": "90",
        "y": "90",
        "k": "30"
      }
    },
    "names": {
      "en": "Coral red"
    }
  },
  "3017": {
    "code": "3017",
    "scope": "classic",
    "color": {
      "hex": "#CB555D",
      "websafe": "#cc6666",
      "rgb": {
        "r": 203,
        "g": 85,
        "b": 93
      },
      "hsl": {
        "h": 356,
        "s": 53,
        "l": 56
      },
      "hsb": {
        "h": 356,
        "s": 58,
        "b": 80
      },
      "cmyk": {
        "c": "0",
        "m": "80",
        "y": "50",
        "k": "10"
      }
    },
    "names": {
      "en": "Rose"
    }
  },
  "3018": {
    "code": "3018",
    "scope": "classic",
    "color": {
      "hex": "#C73F4A",
      "websafe": "#cc3333",
      "rgb": {
        "r": 199,
        "g": 63,
        "b": 74
      },
      "hsl": {
        "h": 355,
        "s": 55,
        "l": 51
      },
      "hsb": {
        "h": 355,
        "s": 68,
        "b": 78
      },
      "cmyk": {
        "c": "5",
        "m": "100",
        "y": "60",
        "k": "0"
      }
    },
    "names": {
      "en": "Strawberry red"
    }
  },
  "3020": {
    "code": "3020",
    "scope": "classic",
    "color": {
      "hex": "#BB1E10",
      "websafe": "#cc3300",
      "rgb": {
        "r": 187,
        "g": 30,
        "b": 16
      },
      "hsl": {
        "h": 5,
        "s": 84,
        "l": 40
      },
      "hsb": {
        "h": 5,
        "s": 91,
        "b": 73
      },
      "cmyk": {
        "c": "0",
        "m": "100",
        "y": "100",
        "k": "10"
      }
    },
    "names": {
      "en": "Traffic red"
    }
  },
  "3022": {
    "code": "3022",
    "scope": "classic",
    "color": {
      "hex": "#CF6955",
      "websafe": "#cc6666",
      "rgb": {
        "r": 207,
        "g": 105,
        "b": 85
      },
      "hsl": {
        "h": 10,
        "s": 56,
        "l": 57
      },
      "hsb": {
        "h": 10,
        "s": 59,
        "b": 81
      },
      "cmyk": {
        "c": "0",
        "m": "70",
        "y": "60",
        "k": "5"
      }
    },
    "names": {
      "en": "Salmon pink"
    }
  },
  "3024": {
    "code": "3024",
    "scope": "classic",
    "color": {
      "hex": "#FF2D21",
      "websafe": "#ff3333",
      "rgb": {
        "r": 255,
        "g": 45,
        "b": 33
      },
      "hsl": {
        "h": 3,
        "s": 100,
        "l": 56
      },
      "hsb": {
        "h": 3,
        "s": 87,
        "b": 100
      },
      "cmyk": {
        "c": "0",
        "m": "90",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Luminous red"
    }
  },
  "3026": {
    "code": "3026",
    "scope": "classic",
    "color": {
      "hex": "#FF2A1B",
      "websafe": "#ff3333",
      "rgb": {
        "r": 255,
        "g": 42,
        "b": 27
      },
      "hsl": {
        "h": 4,
        "s": 100,
        "l": 55
      },
      "hsb": {
        "h": 4,
        "s": 89,
        "b": 100
      },
      "cmyk": {
        "c": "0",
        "m": "80",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Luminous bright red"
    }
  },
  "3027": {
    "code": "3027",
    "scope": "classic",
    "color": {
      "hex": "#AB273C",
      "websafe": "#993333",
      "rgb": {
        "r": 171,
        "g": 39,
        "b": 60
      },
      "hsl": {
        "h": 350,
        "s": 63,
        "l": 41
      },
      "hsb": {
        "h": 350,
        "s": 77,
        "b": 67
      },
      "cmyk": {
        "c": "0",
        "m": "100",
        "y": "50",
        "k": "20"
      }
    },
    "names": {
      "en": "Raspberry red"
    }
  },
  "3028": {
    "code": "3028",
    "scope": "classic",
    "color": {
      "hex": "#CC2C24",
      "websafe": "#cc3333",
      "rgb": {
        "r": 204,
        "g": 44,
        "b": 36
      },
      "hsl": {
        "h": 3,
        "s": 70,
        "l": 47
      },
      "hsb": {
        "h": 3,
        "s": 82,
        "b": 80
      },
      "cmyk": {
        "c": "0",
        "m": "100",
        "y": "90",
        "k": "0"
      }
    },
    "names": {
      "en": "Pure red"
    }
  },
  "3031": {
    "code": "3031",
    "scope": "classic",
    "color": {
      "hex": "#A63437",
      "websafe": "#993333",
      "rgb": {
        "r": 166,
        "g": 52,
        "b": 55
      },
      "hsl": {
        "h": 358,
        "s": 52,
        "l": 43
      },
      "hsb": {
        "h": 358,
        "s": 69,
        "b": 65
      },
      "cmyk": {
        "c": "20",
        "m": "100",
        "y": "70",
        "k": "10"
      }
    },
    "names": {
      "en": "Orient red"
    }
  },
  "3032": {
    "code": "3032",
    "scope": "classic",
    "color": {
      "hex": "#701D23",
      "websafe": "#663333",
      "rgb": {
        "r": 112,
        "g": 29,
        "b": 35
      },
      "hsl": {
        "h": 356,
        "s": 59,
        "l": 28
      },
      "hsb": {
        "h": 356,
        "s": 74,
        "b": 44
      },
      "cmyk": {
        "c": "10",
        "m": "100",
        "y": "60",
        "k": "40"
      }
    },
    "names": {
      "en": "Pearl ruby red"
    }
  },
  "3033": {
    "code": "3033",
    "scope": "classic",
    "color": {
      "hex": "#A53A2D",
      "websafe": "#993333",
      "rgb": {
        "r": 165,
        "g": 58,
        "b": 45
      },
      "hsl": {
        "h": 7,
        "s": 57,
        "l": 41
      },
      "hsb": {
        "h": 7,
        "s": 73,
        "b": 65
      },
      "cmyk": {
        "c": "10",
        "m": "90",
        "y": "90",
        "k": "20"
      }
    },
    "names": {
      "en": "Pearl pink"
    }
  },
  "4001": {
    "code": "4001",
    "scope": "classic",
    "color": {
      "hex": "#816183",
      "websafe": "#996699",
      "rgb": {
        "r": 129,
        "g": 97,
        "b": 131
      },
      "hsl": {
        "h": 296,
        "s": 15,
        "l": 45
      },
      "hsb": {
        "h": 296,
        "s": 26,
        "b": 51
      },
      "cmyk": {
        "c": "30",
        "m": "60",
        "y": "10",
        "k": "20"
      }
    },
    "names": {
      "en": "Red lilac"
    }
  },
  "4002": {
    "code": "4002",
    "scope": "classic",
    "color": {
      "hex": "#8D3C4B",
      "websafe": "#993333",
      "rgb": {
        "r": 141,
        "g": 60,
        "b": 75
      },
      "hsl": {
        "h": 349,
        "s": 40,
        "l": 39
      },
      "hsb": {
        "h": 349,
        "s": 57,
        "b": 55
      },
      "cmyk": {
        "c": "25",
        "m": "90",
        "y": "50",
        "k": "30"
      }
    },
    "names": {
      "en": "Red violet"
    }
  },
  "4003": {
    "code": "4003",
    "scope": "classic",
    "color": {
      "hex": "#C4618C",
      "websafe": "#cc6699",
      "rgb": {
        "r": 196,
        "g": 97,
        "b": 140
      },
      "hsl": {
        "h": 334,
        "s": 46,
        "l": 57
      },
      "hsb": {
        "h": 334,
        "s": 51,
        "b": 77
      },
      "cmyk": {
        "c": "10",
        "m": "80",
        "y": "5",
        "k": "5"
      }
    },
    "names": {
      "en": "Heather violet"
    }
  },
  "4004": {
    "code": "4004",
    "scope": "classic",
    "color": {
      "hex": "#651E38",
      "websafe": "#663333",
      "rgb": {
        "r": 101,
        "g": 30,
        "b": 56
      },
      "hsl": {
        "h": 338,
        "s": 54,
        "l": 26
      },
      "hsb": {
        "h": 338,
        "s": 70,
        "b": 40
      },
      "cmyk": {
        "c": "30",
        "m": "100",
        "y": "30",
        "k": "60"
      }
    },
    "names": {
      "en": "Claret violet"
    }
  },
  "4005": {
    "code": "4005",
    "scope": "classic",
    "color": {
      "hex": "#76689A",
      "websafe": "#666699",
      "rgb": {
        "r": 118,
        "g": 104,
        "b": 154
      },
      "hsl": {
        "h": 257,
        "s": 20,
        "l": 51
      },
      "hsb": {
        "h": 257,
        "s": 32,
        "b": 60
      },
      "cmyk": {
        "c": "50",
        "m": "60",
        "y": "0",
        "k": "0"
      }
    },
    "names": {
      "en": "Blue lilac"
    }
  },
  "4006": {
    "code": "4006",
    "scope": "classic",
    "color": {
      "hex": "#903373",
      "websafe": "#993366",
      "rgb": {
        "r": 144,
        "g": 51,
        "b": 115
      },
      "hsl": {
        "h": 319,
        "s": 48,
        "l": 38
      },
      "hsb": {
        "h": 319,
        "s": 65,
        "b": 56
      },
      "cmyk": {
        "c": "40",
        "m": "100",
        "y": "0",
        "k": "15"
      }
    },
    "names": {
      "en": "Traffic purple"
    }
  },
  "4007": {
    "code": "4007",
    "scope": "classic",
    "color": {
      "hex": "#47243C",
      "websafe": "#333333",
      "rgb": {
        "r": 71,
        "g": 36,
        "b": 60
      },
      "hsl": {
        "h": 319,
        "s": 33,
        "l": 21
      },
      "hsb": {
        "h": 319,
        "s": 49,
        "b": 28
      },
      "cmyk": {
        "c": "70",
        "m": "100",
        "y": "10",
        "k": "70"
      }
    },
    "names": {
      "en": "Purple violet"
    }
  },
  "4008": {
    "code": "4008",
    "scope": "classic",
    "color": {
      "hex": "#844C82",
      "websafe": "#993399",
      "rgb": {
        "r": 132,
        "g": 76,
        "b": 130
      },
      "hsl": {
        "h": 302,
        "s": 27,
        "l": 41
      },
      "hsb": {
        "h": 302,
        "s": 42,
        "b": 52
      },
      "cmyk": {
        "c": "50",
        "m": "90",
        "y": "0",
        "k": "5"
      }
    },
    "names": {
      "en": "Signal violet"
    }
  },
  "4009": {
    "code": "4009",
    "scope": "classic",
    "color": {
      "hex": "#9D8692",
      "websafe": "#999999",
      "rgb": {
        "r": 157,
        "g": 134,
        "b": 146
      },
      "hsl": {
        "h": 329,
        "s": 11,
        "l": 57
      },
      "hsb": {
        "h": 329,
        "s": 15,
        "b": 62
      },
      "cmyk": {
        "c": "35",
        "m": "50",
        "y": "30",
        "k": "10"
      }
    },
    "names": {
      "en": "Pastel violet"
    }
  },
  "4010": {
    "code": "4010",
    "scope": "classic",
    "color": {
      "hex": "#BC4077",
      "websafe": "#cc3366",
      "rgb": {
        "r": 188,
        "g": 64,
        "b": 119
      },
      "hsl": {
        "h": 333,
        "s": 49,
        "l": 49
      },
      "hsb": {
        "h": 333,
        "s": 66,
        "b": 74
      },
      "cmyk": {
        "c": "15",
        "m": "100",
        "y": "15",
        "k": "10"
      }
    },
    "names": {
      "en": "Telemagenta"
    }
  },
  "4011": {
    "code": "4011",
    "scope": "classic",
    "color": {
      "hex": "#6E6387",
      "websafe": "#666699",
      "rgb": {
        "r": 110,
        "g": 99,
        "b": 135
      },
      "hsl": {
        "h": 258,
        "s": 15,
        "l": 46
      },
      "hsb": {
        "h": 258,
        "s": 27,
        "b": 53
      },
      "cmyk": {
        "c": "50",
        "m": "60",
        "y": "0",
        "k": "20"
      }
    },
    "names": {
      "en": "Pearl violet"
    }
  },
  "4012": {
    "code": "4012",
    "scope": "classic",
    "color": {
      "hex": "#6B6B7F",
      "websafe": "#666666",
      "rgb": {
        "r": 107,
        "g": 107,
        "b": 127
      },
      "hsl": {
        "h": 240,
        "s": 9,
        "l": 46
      },
      "hsb": {
        "h": 240,
        "s": 16,
        "b": 50
      },
      "cmyk": {
        "c": "40",
        "m": "35",
        "y": "0",
        "k": "40"
      }
    },
    "names": {
      "en": "Pearl blackberry"
    }
  },
  "5000": {
    "code": "5000",
    "scope": "classic",
    "color": {
      "hex": "#314F6F",
      "websafe": "#336666",
      "rgb": {
        "r": 49,
        "g": 79,
        "b": 111
      },
      "hsl": {
        "h": 211,
        "s": 39,
        "l": 31
      },
      "hsb": {
        "h": 211,
        "s": 56,
        "b": 44
      },
      "cmyk": {
        "c": "100",
        "m": "80",
        "y": "40",
        "k": "5"
      }
    },
    "names": {
      "en": "Violet blue"
    }
  },
  "5001": {
    "code": "5001",
    "scope": "classic",
    "color": {
      "hex": "#0F4C64",
      "websafe": "#003366",
      "rgb": {
        "r": 15,
        "g": 76,
        "b": 100
      },
      "hsl": {
        "h": 197,
        "s": 74,
        "l": 23
      },
      "hsb": {
        "h": 197,
        "s": 85,
        "b": 39
      },
      "cmyk": {
        "c": "100",
        "m": "60",
        "y": "30",
        "k": "40"
      }
    },
    "names": {
      "en": "Green blue"
    }
  },
  "5002": {
    "code": "5002",
    "scope": "classic",
    "color": {
      "hex": "#00387B",
      "websafe": "#003366",
      "rgb": {
        "r": 0,
        "g": 56,
        "b": 123
      },
      "hsl": {
        "h": 213,
        "s": 100,
        "l": 24
      },
      "hsb": {
        "h": 213,
        "s": 100,
        "b": 48
      },
      "cmyk": {
        "c": "100",
        "m": "90",
        "y": "0",
        "k": "10"
      }
    },
    "names": {
      "en": "Ultramarine blue"
    }
  },
  "5003": {
    "code": "5003",
    "scope": "classic",
    "color": {
      "hex": "#1F3855",
      "websafe": "#333366",
      "rgb": {
        "r": 31,
        "g": 56,
        "b": 85
      },
      "hsl": {
        "h": 212,
        "s": 47,
        "l": 23
      },
      "hsb": {
        "h": 212,
        "s": 64,
        "b": 33
      },
      "cmyk": {
        "c": "70",
        "m": "30",
        "y": "10",
        "k": "80"
      }
    },
    "names": {
      "en": "Sapphire blue"
    }
  },
  "5004": {
    "code": "5004",
    "scope": "classic",
    "color": {
      "hex": "#191E28",
      "websafe": "#003333",
      "rgb": {
        "r": 25,
        "g": 30,
        "b": 40
      },
      "hsl": {
        "h": 220,
        "s": 23,
        "l": 13
      },
      "hsb": {
        "h": 220,
        "s": 38,
        "b": 16
      },
      "cmyk": {
        "c": "70",
        "m": "30",
        "y": "10",
        "k": "80"
      }
    },
    "names": {
      "en": "Black blue"
    }
  },
  "5005": {
    "code": "5005",
    "scope": "classic",
    "color": {
      "hex": "#005387",
      "websafe": "#006699",
      "rgb": {
        "r": 0,
        "g": 83,
        "b": 135
      },
      "hsl": {
        "h": 203,
        "s": 100,
        "l": 26
      },
      "hsb": {
        "h": 203,
        "s": 100,
        "b": 53
      },
      "cmyk": {
        "c": "95",
        "m": "60",
        "y": "0",
        "k": "20"
      }
    },
    "names": {
      "en": "Signal blue"
    }
  },
  "5007": {
    "code": "5007",
    "scope": "classic",
    "color": {
      "hex": "#376B8C",
      "websafe": "#336699",
      "rgb": {
        "r": 55,
        "g": 107,
        "b": 140
      },
      "hsl": {
        "h": 203,
        "s": 44,
        "l": 38
      },
      "hsb": {
        "h": 203,
        "s": 61,
        "b": 55
      },
      "cmyk": {
        "c": "80",
        "m": "50",
        "y": "20",
        "k": "20"
      }
    },
    "names": {
      "en": "Brilliant blue"
    }
  },
  "5008": {
    "code": "5008",
    "scope": "classic",
    "color": {
      "hex": "#2B3A44",
      "websafe": "#333333",
      "rgb": {
        "r": 43,
        "g": 58,
        "b": 68
      },
      "hsl": {
        "h": 204,
        "s": 23,
        "l": 22
      },
      "hsb": {
        "h": 204,
        "s": 37,
        "b": 27
      },
      "cmyk": {
        "c": "100",
        "m": "90",
        "y": "60",
        "k": "30"
      }
    },
    "names": {
      "en": "Grey blue"
    }
  },
  "5009": {
    "code": "5009",
    "scope": "classic",
    "color": {
      "hex": "#225F78",
      "websafe": "#336666",
      "rgb": {
        "r": 34,
        "g": 95,
        "b": 120
      },
      "hsl": {
        "h": 197,
        "s": 56,
        "l": 30
      },
      "hsb": {
        "h": 197,
        "s": 72,
        "b": 47
      },
      "cmyk": {
        "c": "90",
        "m": "40",
        "y": "0",
        "k": "30"
      }
    },
    "names": {
      "en": "Azure blue"
    }
  },
  "5010": {
    "code": "5010",
    "scope": "classic",
    "color": {
      "hex": "#004F7C",
      "websafe": "#006666",
      "rgb": {
        "r": 0,
        "g": 79,
        "b": 124
      },
      "hsl": {
        "h": 202,
        "s": 100,
        "l": 24
      },
      "hsb": {
        "h": 202,
        "s": 100,
        "b": 49
      },
      "cmyk": {
        "c": "100",
        "m": "70",
        "y": "5",
        "k": "15"
      }
    },
    "names": {
      "en": "Gentian blue"
    }
  },
  "5011": {
    "code": "5011",
    "scope": "classic",
    "color": {
      "hex": "#1A2B3C",
      "websafe": "#333333",
      "rgb": {
        "r": 26,
        "g": 43,
        "b": 60
      },
      "hsl": {
        "h": 210,
        "s": 40,
        "l": 17
      },
      "hsb": {
        "h": 210,
        "s": 57,
        "b": 24
      },
      "cmyk": {
        "c": "100",
        "m": "100",
        "y": "60",
        "k": "30"
      }
    },
    "names": {
      "en": "Steel blue"
    }
  },
  "5012": {
    "code": "5012",
    "scope": "classic",
    "color": {
      "hex": "#0089B6",
      "websafe": "#0099cc",
      "rgb": {
        "r": 0,
        "g": 137,
        "b": 182
      },
      "hsl": {
        "h": 195,
        "s": 100,
        "l": 36
      },
      "hsb": {
        "h": 195,
        "s": 100,
        "b": 71
      },
      "cmyk": {
        "c": "75",
        "m": "30",
        "y": "0",
        "k": "10"
      }
    },
    "names": {
      "en": "Light blue"
    }
  },
  "5013": {
    "code": "5013",
    "scope": "classic",
    "color": {
      "hex": "#193153",
      "websafe": "#003366",
      "rgb": {
        "r": 25,
        "g": 49,
        "b": 83
      },
      "hsl": {
        "h": 215,
        "s": 54,
        "l": 21
      },
      "hsb": {
        "h": 215,
        "s": 70,
        "b": 33
      },
      "cmyk": {
        "c": "100",
        "m": "80",
        "y": "10",
        "k": "50"
      }
    },
    "names": {
      "en": "Cobalt blue"
    }
  },
  "5014": {
    "code": "5014",
    "scope": "classic",
    "color": {
      "hex": "#637D96",
      "websafe": "#666699",
      "rgb": {
        "r": 99,
        "g": 125,
        "b": 150
      },
      "hsl": {
        "h": 209,
        "s": 20,
        "l": 49
      },
      "hsb": {
        "h": 209,
        "s": 34,
        "b": 59
      },
      "cmyk": {
        "c": "50",
        "m": "30",
        "y": "10",
        "k": "30"
      }
    },
    "names": {
      "en": "Pigeon blue"
    }
  },
  "5015": {
    "code": "5015",
    "scope": "classic",
    "color": {
      "hex": "#007CB0",
      "websafe": "#006699",
      "rgb": {
        "r": 0,
        "g": 124,
        "b": 176
      },
      "hsl": {
        "h": 198,
        "s": 100,
        "l": 35
      },
      "hsb": {
        "h": 198,
        "s": 100,
        "b": 69
      },
      "cmyk": {
        "c": "90",
        "m": "40",
        "y": "0",
        "k": "0"
      }
    },
    "names": {
      "en": "Sky blue"
    }
  },
  "5017": {
    "code": "5017",
    "scope": "classic",
    "color": {
      "hex": "#005B8C",
      "websafe": "#006699",
      "rgb": {
        "r": 0,
        "g": 91,
        "b": 140
      },
      "hsl": {
        "h": 201,
        "s": 100,
        "l": 27
      },
      "hsb": {
        "h": 201,
        "s": 100,
        "b": 55
      },
      "cmyk": {
        "c": "100",
        "m": "60",
        "y": "0",
        "k": "10"
      }
    },
    "names": {
      "en": "Traffic blue"
    }
  },
  "5018": {
    "code": "5018",
    "scope": "classic",
    "color": {
      "hex": "#058B8C",
      "websafe": "#009999",
      "rgb": {
        "r": 5,
        "g": 139,
        "b": 140
      },
      "hsl": {
        "h": 180,
        "s": 93,
        "l": 28
      },
      "hsb": {
        "h": 180,
        "s": 96,
        "b": 55
      },
      "cmyk": {
        "c": "80",
        "m": "10",
        "y": "35",
        "k": "20"
      }
    },
    "names": {
      "en": "Turquoise blue"
    }
  },
  "5019": {
    "code": "5019",
    "scope": "classic",
    "color": {
      "hex": "#005E83",
      "websafe": "#006699",
      "rgb": {
        "r": 0,
        "g": 94,
        "b": 131
      },
      "hsl": {
        "h": 197,
        "s": 100,
        "l": 26
      },
      "hsb": {
        "h": 197,
        "s": 100,
        "b": 51
      },
      "cmyk": {
        "c": "100",
        "m": "50",
        "y": "15",
        "k": "25"
      }
    },
    "names": {
      "en": "Capri blue"
    }
  },
  "5020": {
    "code": "5020",
    "scope": "classic",
    "color": {
      "hex": "#00414B",
      "websafe": "#003333",
      "rgb": {
        "r": 0,
        "g": 65,
        "b": 75
      },
      "hsl": {
        "h": 188,
        "s": 100,
        "l": 15
      },
      "hsb": {
        "h": 188,
        "s": 100,
        "b": 29
      },
      "cmyk": {
        "c": "100",
        "m": "10",
        "y": "20",
        "k": "80"
      }
    },
    "names": {
      "en": "Ocean blue"
    }
  },
  "5021": {
    "code": "5021",
    "scope": "classic",
    "color": {
      "hex": "#007577",
      "websafe": "#006666",
      "rgb": {
        "r": 0,
        "g": 117,
        "b": 119
      },
      "hsl": {
        "h": 181,
        "s": 100,
        "l": 23
      },
      "hsb": {
        "h": 181,
        "s": 100,
        "b": 47
      },
      "cmyk": {
        "c": "100",
        "m": "0",
        "y": "40",
        "k": "35"
      }
    },
    "names": {
      "en": "Water blue"
    }
  },
  "5022": {
    "code": "5022",
    "scope": "classic",
    "color": {
      "hex": "#222D5A",
      "websafe": "#333366",
      "rgb": {
        "r": 34,
        "g": 45,
        "b": 90
      },
      "hsl": {
        "h": 228,
        "s": 45,
        "l": 24
      },
      "hsb": {
        "h": 228,
        "s": 62,
        "b": 35
      },
      "cmyk": {
        "c": "100",
        "m": "90",
        "y": "0",
        "k": "50"
      }
    },
    "names": {
      "en": "Night blue"
    }
  },
  "5023": {
    "code": "5023",
    "scope": "classic",
    "color": {
      "hex": "#42698C",
      "websafe": "#336699",
      "rgb": {
        "r": 66,
        "g": 105,
        "b": 140
      },
      "hsl": {
        "h": 208,
        "s": 36,
        "l": 40
      },
      "hsb": {
        "h": 208,
        "s": 53,
        "b": 55
      },
      "cmyk": {
        "c": "70",
        "m": "40",
        "y": "10",
        "k": "30"
      }
    },
    "names": {
      "en": "Distant blue"
    }
  },
  "5024": {
    "code": "5024",
    "scope": "classic",
    "color": {
      "hex": "#6093AC",
      "websafe": "#669999",
      "rgb": {
        "r": 96,
        "g": 147,
        "b": 172
      },
      "hsl": {
        "h": 200,
        "s": 31,
        "l": 53
      },
      "hsb": {
        "h": 200,
        "s": 44,
        "b": 67
      },
      "cmyk": {
        "c": "60",
        "m": "20",
        "y": "5",
        "k": "20"
      }
    },
    "names": {
      "en": "Pastel blue"
    }
  },
  "5025": {
    "code": "5025",
    "scope": "classic",
    "color": {
      "hex": "#21697C",
      "websafe": "#336666",
      "rgb": {
        "r": 33,
        "g": 105,
        "b": 124
      },
      "hsl": {
        "h": 193,
        "s": 58,
        "l": 31
      },
      "hsb": {
        "h": 193,
        "s": 73,
        "b": 49
      },
      "cmyk": {
        "c": "80",
        "m": "25",
        "y": "5",
        "k": "60"
      }
    },
    "names": {
      "en": "Pearl gentian blue"
    }
  },
  "5026": {
    "code": "5026",
    "scope": "classic",
    "color": {
      "hex": "#0F3052",
      "websafe": "#003366",
      "rgb": {
        "r": 15,
        "g": 48,
        "b": 82
      },
      "hsl": {
        "h": 210,
        "s": 69,
        "l": 19
      },
      "hsb": {
        "h": 210,
        "s": 82,
        "b": 32
      },
      "cmyk": {
        "c": "100",
        "m": "60",
        "y": "0",
        "k": "45"
      }
    },
    "names": {
      "en": "Pearl night blue"
    }
  },
  "6000": {
    "code": "6000",
    "scope": "classic",
    "color": {
      "hex": "#3C7460",
      "websafe": "#336666",
      "rgb": {
        "r": 60,
        "g": 116,
        "b": 96
      },
      "hsl": {
        "h": 159,
        "s": 32,
        "l": 35
      },
      "hsb": {
        "h": 159,
        "s": 48,
        "b": 45
      },
      "cmyk": {
        "c": "80",
        "m": "25",
        "y": "60",
        "k": "15"
      }
    },
    "names": {
      "en": "Patina green"
    }
  },
  "6001": {
    "code": "6001",
    "scope": "classic",
    "color": {
      "hex": "#366735",
      "websafe": "#336633",
      "rgb": {
        "r": 54,
        "g": 103,
        "b": 53
      },
      "hsl": {
        "h": 119,
        "s": 32,
        "l": 31
      },
      "hsb": {
        "h": 119,
        "s": 49,
        "b": 40
      },
      "cmyk": {
        "c": "80",
        "m": "30",
        "y": "100",
        "k": "10"
      }
    },
    "names": {
      "en": "Emerald green"
    }
  },
  "6002": {
    "code": "6002",
    "scope": "classic",
    "color": {
      "hex": "#325928",
      "websafe": "#336633",
      "rgb": {
        "r": 50,
        "g": 89,
        "b": 40
      },
      "hsl": {
        "h": 108,
        "s": 38,
        "l": 25
      },
      "hsb": {
        "h": 108,
        "s": 55,
        "b": 35
      },
      "cmyk": {
        "c": "85",
        "m": "30",
        "y": "100",
        "k": "30"
      }
    },
    "names": {
      "en": "Leaf green"
    }
  },
  "6003": {
    "code": "6003",
    "scope": "classic",
    "color": {
      "hex": "#50533C",
      "websafe": "#666633",
      "rgb": {
        "r": 80,
        "g": 83,
        "b": 60
      },
      "hsl": {
        "h": 68,
        "s": 16,
        "l": 28
      },
      "hsb": {
        "h": 68,
        "s": 28,
        "b": 33
      },
      "cmyk": {
        "c": "45",
        "m": "15",
        "y": "60",
        "k": "70"
      }
    },
    "names": {
      "en": "Olive green"
    }
  },
  "6004": {
    "code": "6004",
    "scope": "classic",
    "color": {
      "hex": "#024442",
      "websafe": "#003333",
      "rgb": {
        "r": 2,
        "g": 68,
        "b": 66
      },
      "hsl": {
        "h": 178,
        "s": 94,
        "l": 14
      },
      "hsb": {
        "h": 178,
        "s": 97,
        "b": 27
      },
      "cmyk": {
        "c": "90",
        "m": "10",
        "y": "45",
        "k": "70"
      }
    },
    "names": {
      "en": "Blue green"
    }
  },
  "6005": {
    "code": "6005",
    "scope": "classic",
    "color": {
      "hex": "#114232",
      "websafe": "#003333",
      "rgb": {
        "r": 17,
        "g": 66,
        "b": 50
      },
      "hsl": {
        "h": 160,
        "s": 59,
        "l": 16
      },
      "hsb": {
        "h": 160,
        "s": 74,
        "b": 26
      },
      "cmyk": {
        "c": "80",
        "m": "5",
        "y": "60",
        "k": "70"
      }
    },
    "names": {
      "en": "Moss green"
    }
  },
  "6006": {
    "code": "6006",
    "scope": "classic",
    "color": {
      "hex": "#3C392E",
      "websafe": "#333333",
      "rgb": {
        "r": 60,
        "g": 57,
        "b": 46
      },
      "hsl": {
        "h": 47,
        "s": 13,
        "l": 21
      },
      "hsb": {
        "h": 47,
        "s": 23,
        "b": 24
      },
      "cmyk": {
        "c": "20",
        "m": "0",
        "y": "30",
        "k": "90"
      }
    },
    "names": {
      "en": "Grey olive"
    }
  },
  "6007": {
    "code": "6007",
    "scope": "classic",
    "color": {
      "hex": "#2C3222",
      "websafe": "#333333",
      "rgb": {
        "r": 44,
        "g": 50,
        "b": 34
      },
      "hsl": {
        "h": 83,
        "s": 19,
        "l": 16
      },
      "hsb": {
        "h": 83,
        "s": 32,
        "b": 20
      },
      "cmyk": {
        "c": "80",
        "m": "45",
        "y": "70",
        "k": "80"
      }
    },
    "names": {
      "en": "Bottle green"
    }
  },
  "6008": {
    "code": "6008",
    "scope": "classic",
    "color": {
      "hex": "#37342A",
      "websafe": "#333333",
      "rgb": {
        "r": 55,
        "g": 52,
        "b": 42
      },
      "hsl": {
        "h": 46,
        "s": 13,
        "l": 19
      },
      "hsb": {
        "h": 46,
        "s": 24,
        "b": 22
      },
      "cmyk": {
        "c": "60",
        "m": "50",
        "y": "60",
        "k": "80"
      }
    },
    "names": {
      "en": "Brown green"
    }
  },
  "6009": {
    "code": "6009",
    "scope": "classic",
    "color": {
      "hex": "#27352A",
      "websafe": "#333333",
      "rgb": {
        "r": 39,
        "g": 53,
        "b": 42
      },
      "hsl": {
        "h": 133,
        "s": 15,
        "l": 18
      },
      "hsb": {
        "h": 133,
        "s": 26,
        "b": 21
      },
      "cmyk": {
        "c": "100",
        "m": "30",
        "y": "80",
        "k": "80"
      }
    },
    "names": {
      "en": "Fir green"
    }
  },
  "6010": {
    "code": "6010",
    "scope": "classic",
    "color": {
      "hex": "#4D6F39",
      "websafe": "#666633",
      "rgb": {
        "r": 77,
        "g": 111,
        "b": 57
      },
      "hsl": {
        "h": 98,
        "s": 32,
        "l": 33
      },
      "hsb": {
        "h": 98,
        "s": 49,
        "b": 44
      },
      "cmyk": {
        "c": "80",
        "m": "20",
        "y": "100",
        "k": "25"
      }
    },
    "names": {
      "en": "Grass green"
    }
  },
  "6011": {
    "code": "6011",
    "scope": "classic",
    "color": {
      "hex": "#6C7C59",
      "websafe": "#666666",
      "rgb": {
        "r": 108,
        "g": 124,
        "b": 89
      },
      "hsl": {
        "h": 87,
        "s": 16,
        "l": 42
      },
      "hsb": {
        "h": 87,
        "s": 28,
        "b": 49
      },
      "cmyk": {
        "c": "50",
        "m": "10",
        "y": "60",
        "k": "45"
      }
    },
    "names": {
      "en": "Reseda green"
    }
  },
  "6012": {
    "code": "6012",
    "scope": "classic",
    "color": {
      "hex": "#303D3A",
      "websafe": "#333333",
      "rgb": {
        "r": 48,
        "g": 61,
        "b": 58
      },
      "hsl": {
        "h": 166,
        "s": 12,
        "l": 21
      },
      "hsb": {
        "h": 166,
        "s": 21,
        "b": 24
      },
      "cmyk": {
        "c": "80",
        "m": "45",
        "y": "50",
        "k": "70"
      }
    },
    "names": {
      "en": "Black green"
    }
  },
  "6013": {
    "code": "6013",
    "scope": "classic",
    "color": {
      "hex": "#7D765A",
      "websafe": "#666666",
      "rgb": {
        "r": 125,
        "g": 118,
        "b": 90
      },
      "hsl": {
        "h": 48,
        "s": 16,
        "l": 42
      },
      "hsb": {
        "h": 48,
        "s": 28,
        "b": 49
      },
      "cmyk": {
        "c": "45",
        "m": "25",
        "y": "60",
        "k": "50"
      }
    },
    "names": {
      "en": "Reed green"
    }
  },
  "6014": {
    "code": "6014",
    "scope": "classic",
    "color": {
      "hex": "#474135",
      "websafe": "#333333",
      "rgb": {
        "r": 71,
        "g": 65,
        "b": 53
      },
      "hsl": {
        "h": 40,
        "s": 15,
        "l": 24
      },
      "hsb": {
        "h": 40,
        "s": 25,
        "b": 28
      },
      "cmyk": {
        "c": "20",
        "m": "20",
        "y": "50",
        "k": "90"
      }
    },
    "names": {
      "en": "Yellow olive"
    }
  },
  "6015": {
    "code": "6015",
    "scope": "classic",
    "color": {
      "hex": "#3D3D36",
      "websafe": "#333333",
      "rgb": {
        "r": 61,
        "g": 61,
        "b": 54
      },
      "hsl": {
        "h": 60,
        "s": 6,
        "l": 23
      },
      "hsb": {
        "h": 60,
        "s": 11,
        "b": 24
      },
      "cmyk": {
        "c": "25",
        "m": "5",
        "y": "30",
        "k": "90"
      }
    },
    "names": {
      "en": "Black olive"
    }
  },
  "6016": {
    "code": "6016",
    "scope": "classic",
    "color": {
      "hex": "#00694C",
      "websafe": "#006633",
      "rgb": {
        "r": 0,
        "g": 105,
        "b": 76
      },
      "hsl": {
        "h": 163,
        "s": 100,
        "l": 21
      },
      "hsb": {
        "h": 163,
        "s": 100,
        "b": 41
      },
      "cmyk": {
        "c": "100",
        "m": "20",
        "y": "80",
        "k": "25"
      }
    },
    "names": {
      "en": "Turquoise green"
    }
  },
  "6017": {
    "code": "6017",
    "scope": "classic",
    "color": {
      "hex": "#587F40",
      "websafe": "#666633",
      "rgb": {
        "r": 88,
        "g": 127,
        "b": 64
      },
      "hsl": {
        "h": 97,
        "s": 33,
        "l": 37
      },
      "hsb": {
        "h": 97,
        "s": 50,
        "b": 50
      },
      "cmyk": {
        "c": "70",
        "m": "5",
        "y": "90",
        "k": "20"
      }
    },
    "names": {
      "en": "May green"
    }
  },
  "6018": {
    "code": "6018",
    "scope": "classic",
    "color": {
      "hex": "#61993B",
      "websafe": "#669933",
      "rgb": {
        "r": 97,
        "g": 153,
        "b": 59
      },
      "hsl": {
        "h": 96,
        "s": 44,
        "l": 42
      },
      "hsb": {
        "h": 96,
        "s": 61,
        "b": 60
      },
      "cmyk": {
        "c": "70",
        "m": "0",
        "y": "90",
        "k": "0"
      }
    },
    "names": {
      "en": "Yellow green"
    }
  },
  "6019": {
    "code": "6019",
    "scope": "classic",
    "color": {
      "hex": "#B9CEAC",
      "websafe": "#cccc99",
      "rgb": {
        "r": 185,
        "g": 206,
        "b": 172
      },
      "hsl": {
        "h": 97,
        "s": 26,
        "l": 74
      },
      "hsb": {
        "h": 97,
        "s": 17,
        "b": 81
      },
      "cmyk": {
        "c": "35",
        "m": "0",
        "y": "40",
        "k": "0"
      }
    },
    "names": {
      "en": "Pastel green"
    }
  },
  "6020": {
    "code": "6020",
    "scope": "classic",
    "color": {
      "hex": "#37422F",
      "websafe": "#333333",
      "rgb": {
        "r": 55,
        "g": 66,
        "b": 47
      },
      "hsl": {
        "h": 95,
        "s": 17,
        "l": 22
      },
      "hsb": {
        "h": 95,
        "s": 29,
        "b": 26
      },
      "cmyk": {
        "c": "80",
        "m": "50",
        "y": "90",
        "k": "50"
      }
    },
    "names": {
      "en": "Chrome green"
    }
  },
  "6021": {
    "code": "6021",
    "scope": "classic",
    "color": {
      "hex": "#8A9977",
      "websafe": "#999966",
      "rgb": {
        "r": 138,
        "g": 153,
        "b": 119
      },
      "hsl": {
        "h": 86,
        "s": 14,
        "l": 53
      },
      "hsb": {
        "h": 86,
        "s": 22,
        "b": 60
      },
      "cmyk": {
        "c": "45",
        "m": "5",
        "y": "50",
        "k": "25"
      }
    },
    "names": {
      "en": "Pale green"
    }
  },
  "6022": {
    "code": "6022",
    "scope": "classic",
    "color": {
      "hex": "#3A3327",
      "websafe": "#333333",
      "rgb": {
        "r": 58,
        "g": 51,
        "b": 39
      },
      "hsl": {
        "h": 38,
        "s": 20,
        "l": 19
      },
      "hsb": {
        "h": 38,
        "s": 33,
        "b": 23
      },
      "cmyk": {
        "c": "70",
        "m": "70",
        "y": "100",
        "k": "70"
      }
    },
    "names": {
      "en": "Olive drab"
    }
  },
  "6024": {
    "code": "6024",
    "scope": "classic",
    "color": {
      "hex": "#008351",
      "websafe": "#009966",
      "rgb": {
        "r": 0,
        "g": 131,
        "b": 81
      },
      "hsl": {
        "h": 157,
        "s": 100,
        "l": 26
      },
      "hsb": {
        "h": 157,
        "s": 100,
        "b": 51
      },
      "cmyk": {
        "c": "90",
        "m": "10",
        "y": "80",
        "k": "10"
      }
    },
    "names": {
      "en": "Traffic green"
    }
  },
  "6025": {
    "code": "6025",
    "scope": "classic",
    "color": {
      "hex": "#5E6E3B",
      "websafe": "#666633",
      "rgb": {
        "r": 94,
        "g": 110,
        "b": 59
      },
      "hsl": {
        "h": 79,
        "s": 30,
        "l": 33
      },
      "hsb": {
        "h": 79,
        "s": 46,
        "b": 43
      },
      "cmyk": {
        "c": "70",
        "m": "25",
        "y": "100",
        "k": "20"
      }
    },
    "names": {
      "en": "Fern green"
    }
  },
  "6026": {
    "code": "6026",
    "scope": "classic",
    "color": {
      "hex": "#005F4E",
      "websafe": "#006666",
      "rgb": {
        "r": 0,
        "g": 95,
        "b": 78
      },
      "hsl": {
        "h": 169,
        "s": 100,
        "l": 19
      },
      "hsb": {
        "h": 169,
        "s": 100,
        "b": 37
      },
      "cmyk": {
        "c": "100",
        "m": "10",
        "y": "60",
        "k": "50"
      }
    },
    "names": {
      "en": "Opal green"
    }
  },
  "6027": {
    "code": "6027",
    "scope": "classic",
    "color": {
      "hex": "#7EBAB5",
      "websafe": "#66cccc",
      "rgb": {
        "r": 126,
        "g": 186,
        "b": 181
      },
      "hsl": {
        "h": 175,
        "s": 30,
        "l": 61
      },
      "hsb": {
        "h": 175,
        "s": 32,
        "b": 73
      },
      "cmyk": {
        "c": "50",
        "m": "0",
        "y": "25",
        "k": "5"
      }
    },
    "names": {
      "en": "Light green"
    }
  },
  "6028": {
    "code": "6028",
    "scope": "classic",
    "color": {
      "hex": "#315442",
      "websafe": "#336633",
      "rgb": {
        "r": 49,
        "g": 84,
        "b": 66
      },
      "hsl": {
        "h": 149,
        "s": 26,
        "l": 26
      },
      "hsb": {
        "h": 149,
        "s": 42,
        "b": 33
      },
      "cmyk": {
        "c": "80",
        "m": "35",
        "y": "70",
        "k": "50"
      }
    },
    "names": {
      "en": "Pine green"
    }
  },
  "6029": {
    "code": "6029",
    "scope": "classic",
    "color": {
      "hex": "#006F3D",
      "websafe": "#006633",
      "rgb": {
        "r": 0,
        "g": 111,
        "b": 61
      },
      "hsl": {
        "h": 153,
        "s": 100,
        "l": 22
      },
      "hsb": {
        "h": 153,
        "s": 100,
        "b": 44
      },
      "cmyk": {
        "c": "100",
        "m": "5",
        "y": "90",
        "k": "30"
      }
    },
    "names": {
      "en": "Mint green"
    }
  },
  "6031": {
      "code": "6031",
      "scope": "classic",
      "color": {
          "hex": "#3A4032",
          "websafe": "#333333",
          "rgb": {
              "r": 58,
              "g": 64,
              "b": 50
          },
          "hsl": {
              "h": 86,
              "s": 12,
              "l": 22
          },
          "hsb": {
              "h": 86,
              "s": 22,
              "b": 25
          },
          "cmyk": {
              "c": "10",
              "m": "0",
              "y": "22",
              "k": "75"
          }
      },
      "names": {
          "de": "Bronzegrün",
          "en": "Bronze green",
          "fr": "Vert bronze",
          "es": "Verde bronce",
          "it": "Verde bronzo",
          "nl": "Bronsgroen"
      }
    },
  "6032": {
    "code": "6032",
    "scope": "classic",
    "color": {
      "hex": "#237F52",
      "websafe": "#336666",
      "rgb": {
        "r": 35,
        "g": 127,
        "b": 82
      },
      "hsl": {
        "h": 151,
        "s": 57,
        "l": 32
      },
      "hsb": {
        "h": 151,
        "s": 72,
        "b": 50
      },
      "cmyk": {
        "c": "90",
        "m": "10",
        "y": "80",
        "k": "10"
      }
    },
    "names": {
      "en": "Signal green"
    }
  },
  "6033": {
    "code": "6033",
    "scope": "classic",
    "color": {
      "hex": "#46877F",
      "websafe": "#339966",
      "rgb": {
        "r": 70,
        "g": 135,
        "b": 127
      },
      "hsl": {
        "h": 173,
        "s": 32,
        "l": 40
      },
      "hsb": {
        "h": 173,
        "s": 48,
        "b": 53
      },
      "cmyk": {
        "c": "70",
        "m": "15",
        "y": "50",
        "k": "20"
      }
    },
    "names": {
      "en": "Mint turquoise"
    }
  },
  "6034": {
    "code": "6034",
    "scope": "classic",
    "color": {
      "hex": "#7AACAC",
      "websafe": "#669999",
      "rgb": {
        "r": 122,
        "g": 172,
        "b": 172
      },
      "hsl": {
        "h": 180,
        "s": 23,
        "l": 58
      },
      "hsb": {
        "h": 180,
        "s": 29,
        "b": 67
      },
      "cmyk": {
        "c": "45",
        "m": "0",
        "y": "20",
        "k": "20"
      }
    },
    "names": {
      "en": "Pastel turquoise"
    }
  },
  "6035": {
    "code": "6035",
    "scope": "classic",
    "color": {
      "hex": "#194D25",
      "websafe": "#006633",
      "rgb": {
        "r": 25,
        "g": 77,
        "b": 37
      },
      "hsl": {
        "h": 134,
        "s": 51,
        "l": 20
      },
      "hsb": {
        "h": 134,
        "s": 68,
        "b": 30
      },
      "cmyk": {
        "c": "90",
        "m": "15",
        "y": "100",
        "k": "60"
      }
    },
    "names": {
      "en": "Pearl green"
    }
  },
  "6036": {
    "code": "6036",
    "scope": "classic",
    "color": {
      "hex": "#04574B",
      "websafe": "#006633",
      "rgb": {
        "r": 4,
        "g": 87,
        "b": 75
      },
      "hsl": {
        "h": 171,
        "s": 91,
        "l": 18
      },
      "hsb": {
        "h": 171,
        "s": 95,
        "b": 34
      },
      "cmyk": {
        "c": "85",
        "m": "10",
        "y": "60",
        "k": "40"
      }
    },
    "names": {
      "en": "Pearl opal green"
    }
  },
  "6037": {
    "code": "6037",
    "scope": "classic",
    "color": {
      "hex": "#008B29",
      "websafe": "#009933",
      "rgb": {
        "r": 0,
        "g": 139,
        "b": 41
      },
      "hsl": {
        "h": 138,
        "s": 100,
        "l": 27
      },
      "hsb": {
        "h": 138,
        "s": 100,
        "b": 55
      },
      "cmyk": {
        "c": "85",
        "m": "0",
        "y": "100",
        "k": "0"
      }
    },
    "names": {
      "en": "Pure green"
    }
  },
  "6038": {
    "code": "6038",
    "scope": "classic",
    "color": {
      "hex": "#00B51A",
      "websafe": "#00cc33",
      "rgb": {
        "r": 0,
        "g": 181,
        "b": 26
      },
      "hsl": {
        "h": 129,
        "s": 100,
        "l": 35
      },
      "hsb": {
        "h": 129,
        "s": 100,
        "b": 71
      },
      "cmyk": {
        "c": "70",
        "m": "0",
        "y": "90",
        "k": "0"
      }
    },
    "names": {
      "en": "Luminous green"
    }
  },
  "7000": {
    "code": "7000",
    "scope": "classic",
    "color": {
      "hex": "#7A888E",
      "websafe": "#669999",
      "rgb": {
        "r": 122,
        "g": 136,
        "b": 142
      },
      "hsl": {
        "h": 198,
        "s": 8,
        "l": 52
      },
      "hsb": {
        "h": 198,
        "s": 14,
        "b": 56
      },
      "cmyk": {
        "c": "35",
        "m": "5",
        "y": "10",
        "k": "40"
      }
    },
    "names": {
      "en": "Squirrel grey"
    }
  },
  "7001": {
    "code": "7001",
    "scope": "classic",
    "color": {
      "hex": "#8C969D",
      "websafe": "#999999",
      "rgb": {
        "r": 140,
        "g": 150,
        "b": 157
      },
      "hsl": {
        "h": 205,
        "s": 8,
        "l": 58
      },
      "hsb": {
        "h": 205,
        "s": 11,
        "b": 62
      },
      "cmyk": {
        "c": "25",
        "m": "10",
        "y": "5",
        "k": "45"
      }
    },
    "names": {
      "en": "Silver grey"
    }
  },
  "7002": {
    "code": "7002",
    "scope": "classic",
    "color": {
      "hex": "#817863",
      "websafe": "#996666",
      "rgb": {
        "r": 129,
        "g": 120,
        "b": 99
      },
      "hsl": {
        "h": 42,
        "s": 13,
        "l": 45
      },
      "hsb": {
        "h": 42,
        "s": 23,
        "b": 51
      },
      "cmyk": {
        "c": "0",
        "m": "5",
        "y": "40",
        "k": "60"
      }
    },
    "names": {
      "en": "Olive grey"
    }
  },
  "7003": {
    "code": "7003",
    "scope": "classic",
    "color": {
      "hex": "#7A7669",
      "websafe": "#666666",
      "rgb": {
        "r": 122,
        "g": 118,
        "b": 105
      },
      "hsl": {
        "h": 46,
        "s": 7,
        "l": 45
      },
      "hsb": {
        "h": 46,
        "s": 14,
        "b": 48
      },
      "cmyk": {
        "c": "45",
        "m": "35",
        "y": "45",
        "k": "45"
      }
    },
    "names": {
      "en": "Moss grey"
    }
  },
  "7004": {
    "code": "7004",
    "scope": "classic",
    "color": {
      "hex": "#9B9B9B",
      "websafe": "#999999",
      "rgb": {
        "r": 155,
        "g": 155,
        "b": 155
      },
      "hsl": {
        "h": 0,
        "s": 0,
        "l": 61
      },
      "hsb": {
        "h": 0,
        "s": 0,
        "b": 61
      },
      "cmyk": {
        "c": "15",
        "m": "10",
        "y": "5",
        "k": "45"
      }
    },
    "names": {
      "en": "Signal grey"
    }
  },
  "7005": {
    "code": "7005",
    "scope": "classic",
    "color": {
      "hex": "#6C6E6B",
      "websafe": "#666666",
      "rgb": {
        "r": 108,
        "g": 110,
        "b": 107
      },
      "hsl": {
        "h": 100,
        "s": 1,
        "l": 43
      },
      "hsb": {
        "h": 100,
        "s": 3,
        "b": 43
      },
      "cmyk": {
        "c": "35",
        "m": "20",
        "y": "30",
        "k": "40"
      }
    },
    "names": {
      "en": "Mouse grey"
    }
  },
  "7006": {
    "code": "7006",
    "scope": "classic",
    "color": {
      "hex": "#766A5E",
      "websafe": "#666666",
      "rgb": {
        "r": 118,
        "g": 106,
        "b": 94
      },
      "hsl": {
        "h": 30,
        "s": 11,
        "l": 42
      },
      "hsb": {
        "h": 30,
        "s": 20,
        "b": 46
      },
      "cmyk": {
        "c": "40",
        "m": "40",
        "y": "50",
        "k": "40"
      }
    },
    "names": {
      "en": "Beige grey"
    }
  },
  "7008": {
    "code": "7008",
    "scope": "classic",
    "color": {
      "hex": "#745E3D",
      "websafe": "#666633",
      "rgb": {
        "r": 116,
        "g": 94,
        "b": 61
      },
      "hsl": {
        "h": 36,
        "s": 31,
        "l": 35
      },
      "hsb": {
        "h": 36,
        "s": 47,
        "b": 45
      },
      "cmyk": {
        "c": "40",
        "m": "50",
        "y": "90",
        "k": "40"
      }
    },
    "names": {
      "en": "Khaki grey"
    }
  },
  "7009": {
    "code": "7009",
    "scope": "classic",
    "color": {
      "hex": "#5D6058",
      "websafe": "#666666",
      "rgb": {
        "r": 93,
        "g": 96,
        "b": 88
      },
      "hsl": {
        "h": 83,
        "s": 4,
        "l": 36
      },
      "hsb": {
        "h": 83,
        "s": 8,
        "b": 38
      },
      "cmyk": {
        "c": "50",
        "m": "35",
        "y": "50",
        "k": "50"
      }
    },
    "names": {
      "en": "Green grey"
    }
  },
  "7010": {
    "code": "7010",
    "scope": "classic",
    "color": {
      "hex": "#585C56",
      "websafe": "#666666",
      "rgb": {
        "r": 88,
        "g": 92,
        "b": 86
      },
      "hsl": {
        "h": 100,
        "s": 3,
        "l": 35
      },
      "hsb": {
        "h": 100,
        "s": 7,
        "b": 36
      },
      "cmyk": {
        "c": "50",
        "m": "30",
        "y": "45",
        "k": "60"
      }
    },
    "names": {
      "en": "Tarpaulin grey"
    }
  },
  "7011": {
    "code": "7011",
    "scope": "classic",
    "color": {
      "hex": "#52595D",
      "websafe": "#666666",
      "rgb": {
        "r": 82,
        "g": 89,
        "b": 93
      },
      "hsl": {
        "h": 202,
        "s": 6,
        "l": 34
      },
      "hsb": {
        "h": 202,
        "s": 12,
        "b": 36
      },
      "cmyk": {
        "c": "40",
        "m": "15",
        "y": "15",
        "k": "70"
      }
    },
    "names": {
      "en": "Iron grey"
    }
  },
  "7012": {
    "code": "7012",
    "scope": "classic",
    "color": {
      "hex": "#575D5E",
      "websafe": "#666666",
      "rgb": {
        "r": 87,
        "g": 93,
        "b": 94
      },
      "hsl": {
        "h": 189,
        "s": 4,
        "l": 35
      },
      "hsb": {
        "h": 189,
        "s": 7,
        "b": 37
      },
      "cmyk": {
        "c": "30",
        "m": "10",
        "y": "10",
        "k": "70"
      }
    },
    "names": {
      "en": "Basalt grey"
    }
  },
  "7013": {
    "code": "7013",
    "scope": "classic",
    "color": {
      "hex": "#575044",
      "websafe": "#666633",
      "rgb": {
        "r": 87,
        "g": 80,
        "b": 68
      },
      "hsl": {
        "h": 38,
        "s": 12,
        "l": 30
      },
      "hsb": {
        "h": 38,
        "s": 22,
        "b": 34
      },
      "cmyk": {
        "c": "30",
        "m": "35",
        "y": "50",
        "k": "70"
      }
    },
    "names": {
      "en": "Brown grey"
    }
  },
  "7015": {
    "code": "7015",
    "scope": "classic",
    "color": {
      "hex": "#4F5358",
      "websafe": "#666666",
      "rgb": {
        "r": 79,
        "g": 83,
        "b": 88
      },
      "hsl": {
        "h": 213,
        "s": 5,
        "l": 33
      },
      "hsb": {
        "h": 213,
        "s": 10,
        "b": 35
      },
      "cmyk": {
        "c": "45",
        "m": "30",
        "y": "15",
        "k": "70"
      }
    },
    "names": {
      "en": "Slate grey"
    }
  },
  "7016": {
    "code": "7016",
    "scope": "classic",
    "color": {
      "hex": "#383E42",
      "websafe": "#333333",
      "rgb": {
        "r": 56,
        "g": 62,
        "b": 66
      },
      "hsl": {
        "h": 204,
        "s": 8,
        "l": 24
      },
      "hsb": {
        "h": 204,
        "s": 15,
        "b": 26
      },
      "cmyk": {
        "c": "60",
        "m": "30",
        "y": "20",
        "k": "80"
      }
    },
    "names": {
      "en": "Anthracite grey"
    }
  },
  "7021": {
    "code": "7021",
    "scope": "classic",
    "color": {
      "hex": "#2F3234",
      "websafe": "#333333",
      "rgb": {
        "r": 47,
        "g": 50,
        "b": 52
      },
      "hsl": {
        "h": 204,
        "s": 5,
        "l": 19
      },
      "hsb": {
        "h": 204,
        "s": 10,
        "b": 20
      },
      "cmyk": {
        "c": "60",
        "m": "35",
        "y": "30",
        "k": "90"
      }
    },
    "names": {
      "en": "Black grey"
    }
  },
  "7022": {
    "code": "7022",
    "scope": "classic",
    "color": {
      "hex": "#4C4A44",
      "websafe": "#333333",
      "rgb": {
        "r": 76,
        "g": 74,
        "b": 68
      },
      "hsl": {
        "h": 45,
        "s": 6,
        "l": 28
      },
      "hsb": {
        "h": 45,
        "s": 11,
        "b": 30
      },
      "cmyk": {
        "c": "40",
        "m": "30",
        "y": "40",
        "k": "80"
      }
    },
    "names": {
      "en": "Umbra grey"
    }
  },
  "7023": {
    "code": "7023",
    "scope": "classic",
    "color": {
      "hex": "#808076",
      "websafe": "#999966",
      "rgb": {
        "r": 128,
        "g": 128,
        "b": 118
      },
      "hsl": {
        "h": 60,
        "s": 4,
        "l": 48
      },
      "hsb": {
        "h": 60,
        "s": 8,
        "b": 50
      },
      "cmyk": {
        "c": "5",
        "m": "0",
        "y": "20",
        "k": "50"
      }
    },
    "names": {
      "en": "Concrete grey"
    }
  },
  "7024": {
    "code": "7024",
    "scope": "classic",
    "color": {
      "hex": "#45494E",
      "websafe": "#333366",
      "rgb": {
        "r": 69,
        "g": 73,
        "b": 78
      },
      "hsl": {
        "h": 213,
        "s": 6,
        "l": 29
      },
      "hsb": {
        "h": 213,
        "s": 12,
        "b": 31
      },
      "cmyk": {
        "c": "30",
        "m": "20",
        "y": "0",
        "k": "80"
      }
    },
    "names": {
      "en": "Graphite grey"
    }
  },
  "7026": {
    "code": "7026",
    "scope": "classic",
    "color": {
      "hex": "#374345",
      "websafe": "#333333",
      "rgb": {
        "r": 55,
        "g": 67,
        "b": 69
      },
      "hsl": {
        "h": 189,
        "s": 11,
        "l": 24
      },
      "hsb": {
        "h": 189,
        "s": 20,
        "b": 27
      },
      "cmyk": {
        "c": "50",
        "m": "15",
        "y": "15",
        "k": "80"
      }
    },
    "names": {
      "en": "Granite grey"
    }
  },
  "7030": {
    "code": "7030",
    "scope": "classic",
    "color": {
      "hex": "#928E85",
      "websafe": "#999999",
      "rgb": {
        "r": 146,
        "g": 142,
        "b": 133
      },
      "hsl": {
        "h": 42,
        "s": 6,
        "l": 55
      },
      "hsb": {
        "h": 42,
        "s": 9,
        "b": 57
      },
      "cmyk": {
        "c": "5",
        "m": "5",
        "y": "15",
        "k": "50"
      }
    },
    "names": {
      "en": "Stone grey"
    }
  },
  "7031": {
    "code": "7031",
    "scope": "classic",
    "color": {
      "hex": "#5B686D",
      "websafe": "#666666",
      "rgb": {
        "r": 91,
        "g": 104,
        "b": 109
      },
      "hsl": {
        "h": 197,
        "s": 9,
        "l": 39
      },
      "hsb": {
        "h": 197,
        "s": 17,
        "b": 43
      },
      "cmyk": {
        "c": "50",
        "m": "20",
        "y": "15",
        "k": "60"
      }
    },
    "names": {
      "en": "Blue grey"
    }
  },
  "7032": {
    "code": "7032",
    "scope": "classic",
    "color": {
      "hex": "#B5B0A1",
      "websafe": "#cc9999",
      "rgb": {
        "r": 181,
        "g": 176,
        "b": 161
      },
      "hsl": {
        "h": 45,
        "s": 12,
        "l": 67
      },
      "hsb": {
        "h": 45,
        "s": 11,
        "b": 71
      },
      "cmyk": {
        "c": "15",
        "m": "10",
        "y": "25",
        "k": "20"
      }
    },
    "names": {
      "en": "Pebble grey"
    }
  },
  "7033": {
    "code": "7033",
    "scope": "classic",
    "color": {
      "hex": "#7F8274",
      "websafe": "#669966",
      "rgb": {
        "r": 127,
        "g": 130,
        "b": 116
      },
      "hsl": {
        "h": 73,
        "s": 6,
        "l": 48
      },
      "hsb": {
        "h": 73,
        "s": 11,
        "b": 51
      },
      "cmyk": {
        "c": "25",
        "m": "10",
        "y": "30",
        "k": "40"
      }
    },
    "names": {
      "en": "Cement grey"
    }
  },
  "7034": {
    "code": "7034",
    "scope": "classic",
    "color": {
      "hex": "#92886F",
      "websafe": "#999966",
      "rgb": {
        "r": 146,
        "g": 136,
        "b": 111
      },
      "hsl": {
        "h": 43,
        "s": 14,
        "l": 50
      },
      "hsb": {
        "h": 43,
        "s": 24,
        "b": 57
      },
      "cmyk": {
        "c": "15",
        "m": "20",
        "y": "40",
        "k": "40"
      }
    },
    "names": {
      "en": "Yellow grey"
    }
  },
  "7035": {
    "code": "7035",
    "scope": "classic",
    "color": {
      "hex": "#C5C7C4",
      "websafe": "#cccccc",
      "rgb": {
        "r": 197,
        "g": 199,
        "b": 196
      },
      "hsl": {
        "h": 100,
        "s": 3,
        "l": 77
      },
      "hsb": {
        "h": 100,
        "s": 2,
        "b": 78
      },
      "cmyk": {
        "c": "20",
        "m": "10",
        "y": "15",
        "k": "5"
      }
    },
    "names": {
      "en": "Light grey"
    }
  },
  "7036": {
    "code": "7036",
    "scope": "classic",
    "color": {
      "hex": "#979392",
      "websafe": "#999999",
      "rgb": {
        "r": 151,
        "g": 147,
        "b": 146
      },
      "hsl": {
        "h": 12,
        "s": 2,
        "l": 58
      },
      "hsb": {
        "h": 12,
        "s": 3,
        "b": 59
      },
      "cmyk": {
        "c": "35",
        "m": "30",
        "y": "30",
        "k": "10"
      }
    },
    "names": {
      "en": "Platinum grey"
    }
  },
  "7037": {
    "code": "7037",
    "scope": "classic",
    "color": {
      "hex": "#7A7B7A",
      "websafe": "#666666",
      "rgb": {
        "r": 122,
        "g": 123,
        "b": 122
      },
      "hsl": {
        "h": 120,
        "s": 0,
        "l": 48
      },
      "hsb": {
        "h": 120,
        "s": 1,
        "b": 48
      },
      "cmyk": {
        "c": "30",
        "m": "20",
        "y": "20",
        "k": "40"
      }
    },
    "names": {
      "en": "Dusty grey"
    }
  },
  "7038": {
    "code": "7038",
    "scope": "classic",
    "color": {
      "hex": "#B0B0A9",
      "websafe": "#999999",
      "rgb": {
        "r": 176,
        "g": 176,
        "b": 169
      },
      "hsl": {
        "h": 60,
        "s": 4,
        "l": 68
      },
      "hsb": {
        "h": 60,
        "s": 4,
        "b": 69
      },
      "cmyk": {
        "c": "5",
        "m": "0",
        "y": "10",
        "k": "30"
      }
    },
    "names": {
      "en": "Agate grey"
    }
  },
  "7039": {
    "code": "7039",
    "scope": "classic",
    "color": {
      "hex": "#6B665E",
      "websafe": "#666666",
      "rgb": {
        "r": 107,
        "g": 102,
        "b": 94
      },
      "hsl": {
        "h": 37,
        "s": 6,
        "l": 39
      },
      "hsb": {
        "h": 37,
        "s": 12,
        "b": 42
      },
      "cmyk": {
        "c": "25",
        "m": "20",
        "y": "30",
        "k": "60"
      }
    },
    "names": {
      "en": "Quartz grey"
    }
  },
  "7040": {
    "code": "7040",
    "scope": "classic",
    "color": {
      "hex": "#989EA1",
      "websafe": "#999999",
      "rgb": {
        "r": 152,
        "g": 158,
        "b": 161
      },
      "hsl": {
        "h": 200,
        "s": 5,
        "l": 61
      },
      "hsb": {
        "h": 200,
        "s": 6,
        "b": 63
      },
      "cmyk": {
        "c": "20",
        "m": "10",
        "y": "5",
        "k": "35"
      }
    },
    "names": {
      "en": "Window grey"
    }
  },
  "7042": {
    "code": "7042",
    "scope": "classic",
    "color": {
      "hex": "#8E9291",
      "websafe": "#999999",
      "rgb": {
        "r": 142,
        "g": 146,
        "b": 145
      },
      "hsl": {
        "h": 165,
        "s": 2,
        "l": 56
      },
      "hsb": {
        "h": 165,
        "s": 3,
        "b": 57
      },
      "cmyk": {
        "c": "30",
        "m": "20",
        "y": "30",
        "k": "30"
      }
    },
    "names": {
      "en": "Traffic grey A"
    }
  },
  "7043": {
    "code": "7043",
    "scope": "classic",
    "color": {
      "hex": "#4F5250",
      "websafe": "#666666",
      "rgb": {
        "r": 79,
        "g": 82,
        "b": 80
      },
      "hsl": {
        "h": 140,
        "s": 2,
        "l": 32
      },
      "hsb": {
        "h": 140,
        "s": 4,
        "b": 32
      },
      "cmyk": {
        "c": "20",
        "m": "5",
        "y": "0",
        "k": "80"
      }
    },
    "names": {
      "en": "Traffic grey B"
    }
  },
  "7044": {
    "code": "7044",
    "scope": "classic",
    "color": {
      "hex": "#B7B3A8",
      "websafe": "#cccc99",
      "rgb": {
        "r": 183,
        "g": 179,
        "b": 168
      },
      "hsl": {
        "h": 44,
        "s": 9,
        "l": 69
      },
      "hsb": {
        "h": 44,
        "s": 8,
        "b": 72
      },
      "cmyk": {
        "c": "20",
        "m": "15",
        "y": "25",
        "k": "15"
      }
    },
    "names": {
      "en": "Silk grey"
    }
  },
  "7045": {
    "code": "7045",
    "scope": "classic",
    "color": {
      "hex": "#8D9295",
      "websafe": "#999999",
      "rgb": {
        "r": 141,
        "g": 146,
        "b": 149
      },
      "hsl": {
        "h": 203,
        "s": 4,
        "l": 57
      },
      "hsb": {
        "h": 203,
        "s": 5,
        "b": 58
      },
      "cmyk": {
        "c": "5",
        "m": "0",
        "y": "0",
        "k": "45"
      }
    },
    "names": {
      "en": "Telegrey 1"
    }
  },
  "7046": {
    "code": "7046",
    "scope": "classic",
    "color": {
      "hex": "#7F868A",
      "websafe": "#669999",
      "rgb": {
        "r": 127,
        "g": 134,
        "b": 138
      },
      "hsl": {
        "h": 202,
        "s": 4,
        "l": 52
      },
      "hsb": {
        "h": 202,
        "s": 8,
        "b": 54
      },
      "cmyk": {
        "c": "30",
        "m": "20",
        "y": "20",
        "k": "40"
      }
    },
    "names": {
      "en": "Telegrey 2"
    }
  },
  "7047": {
    "code": "7047",
    "scope": "classic",
    "color": {
      "hex": "#C8C8C7",
      "websafe": "#cccccc",
      "rgb": {
        "r": 200,
        "g": 200,
        "b": 199
      },
      "hsl": {
        "h": 60,
        "s": 1,
        "l": 78
      },
      "hsb": {
        "h": 60,
        "s": 0,
        "b": 78
      },
      "cmyk": {
        "c": "5",
        "m": "5",
        "y": "5",
        "k": "20"
      }
    },
    "names": {
      "en": "Telegrey 4"
    }
  },
  "7048": {
    "code": "7048",
    "scope": "classic",
    "color": {
      "hex": "#817B73",
      "websafe": "#996666",
      "rgb": {
        "r": 129,
        "g": 123,
        "b": 115
      },
      "hsl": {
        "h": 34,
        "s": 6,
        "l": 48
      },
      "hsb": {
        "h": 34,
        "s": 11,
        "b": 51
      },
      "cmyk": {
        "c": "15",
        "m": "15",
        "y": "25",
        "k": "60"
      }
    },
    "names": {
      "en": "Pearl mouse grey"
    }
  },
  "8000": {
    "code": "8000",
    "scope": "classic",
    "color": {
      "hex": "#89693E",
      "websafe": "#996633",
      "rgb": {
        "r": 137,
        "g": 105,
        "b": 62
      },
      "hsl": {
        "h": 34,
        "s": 38,
        "l": 39
      },
      "hsb": {
        "h": 34,
        "s": 55,
        "b": 54
      },
      "cmyk": {
        "c": "50",
        "m": "60",
        "y": "90",
        "k": "0"
      }
    },
    "names": {
      "en": "Green brown"
    }
  },
  "8001": {
    "code": "8001",
    "scope": "classic",
    "color": {
      "hex": "#9D622B",
      "websafe": "#996633",
      "rgb": {
        "r": 157,
        "g": 98,
        "b": 43
      },
      "hsl": {
        "h": 29,
        "s": 57,
        "l": 39
      },
      "hsb": {
        "h": 29,
        "s": 73,
        "b": 62
      },
      "cmyk": {
        "c": "30",
        "m": "60",
        "y": "90",
        "k": "10"
      }
    },
    "names": {
      "en": "Ochre brown"
    }
  },
  "8002": {
    "code": "8002",
    "scope": "classic",
    "color": {
      "hex": "#794D3E",
      "websafe": "#666633",
      "rgb": {
        "r": 121,
        "g": 77,
        "b": 62
      },
      "hsl": {
        "h": 15,
        "s": 32,
        "l": 36
      },
      "hsb": {
        "h": 15,
        "s": 49,
        "b": 47
      },
      "cmyk": {
        "c": "30",
        "m": "70",
        "y": "70",
        "k": "50"
      }
    },
    "names": {
      "en": "Signal brown"
    }
  },
  "8003": {
    "code": "8003",
    "scope": "classic",
    "color": {
      "hex": "#7E4B26",
      "websafe": "#663333",
      "rgb": {
        "r": 126,
        "g": 75,
        "b": 38
      },
      "hsl": {
        "h": 25,
        "s": 54,
        "l": 32
      },
      "hsb": {
        "h": 25,
        "s": 70,
        "b": 49
      },
      "cmyk": {
        "c": "0",
        "m": "60",
        "y": "80",
        "k": "60"
      }
    },
    "names": {
      "en": "Clay brown"
    }
  },
  "8004": {
    "code": "8004",
    "scope": "classic",
    "color": {
      "hex": "#8D4931",
      "websafe": "#993333",
      "rgb": {
        "r": 141,
        "g": 73,
        "b": 49
      },
      "hsl": {
        "h": 16,
        "s": 48,
        "l": 37
      },
      "hsb": {
        "h": 16,
        "s": 65,
        "b": 55
      },
      "cmyk": {
        "c": "45",
        "m": "80",
        "y": "100",
        "k": "10"
      }
    },
    "names": {
      "en": "Copper brown"
    }
  },
  "8007": {
    "code": "8007",
    "scope": "classic",
    "color": {
      "hex": "#70452A",
      "websafe": "#663333",
      "rgb": {
        "r": 112,
        "g": 69,
        "b": 42
      },
      "hsl": {
        "h": 23,
        "s": 45,
        "l": 30
      },
      "hsb": {
        "h": 23,
        "s": 63,
        "b": 44
      },
      "cmyk": {
        "c": "40",
        "m": "70",
        "y": "100",
        "k": "50"
      }
    },
    "names": {
      "en": "Fawn brown"
    }
  },
  "8008": {
    "code": "8008",
    "scope": "classic",
    "color": {
      "hex": "#724A25",
      "websafe": "#663333",
      "rgb": {
        "r": 114,
        "g": 74,
        "b": 37
      },
      "hsl": {
        "h": 29,
        "s": 51,
        "l": 30
      },
      "hsb": {
        "h": 29,
        "s": 68,
        "b": 45
      },
      "cmyk": {
        "c": "15",
        "m": "50",
        "y": "90",
        "k": "60"
      }
    },
    "names": {
      "en": "Olive brown"
    }
  },
  "8011": {
    "code": "8011",
    "scope": "classic",
    "color": {
      "hex": "#5A3826",
      "websafe": "#663333",
      "rgb": {
        "r": 90,
        "g": 56,
        "b": 38
      },
      "hsl": {
        "h": 21,
        "s": 41,
        "l": 25
      },
      "hsb": {
        "h": 21,
        "s": 58,
        "b": 35
      },
      "cmyk": {
        "c": "30",
        "m": "70",
        "y": "90",
        "k": "70"
      }
    },
    "names": {
      "en": "Nut brown"
    }
  },
  "8012": {
    "code": "8012",
    "scope": "classic",
    "color": {
      "hex": "#66332B",
      "websafe": "#663333",
      "rgb": {
        "r": 102,
        "g": 51,
        "b": 43
      },
      "hsl": {
        "h": 8,
        "s": 41,
        "l": 28
      },
      "hsb": {
        "h": 8,
        "s": 58,
        "b": 40
      },
      "cmyk": {
        "c": "40",
        "m": "90",
        "y": "100",
        "k": "50"
      }
    },
    "names": {
      "en": "Red brown"
    }
  },
  "8014": {
    "code": "8014",
    "scope": "classic",
    "color": {
      "hex": "#4A3526",
      "websafe": "#333333",
      "rgb": {
        "r": 74,
        "g": 53,
        "b": 38
      },
      "hsl": {
        "h": 25,
        "s": 32,
        "l": 22
      },
      "hsb": {
        "h": 25,
        "s": 49,
        "b": 29
      },
      "cmyk": {
        "c": "30",
        "m": "60",
        "y": "70",
        "k": "80"
      }
    },
    "names": {
      "en": "Sepia brown"
    }
  },
  "8015": {
    "code": "8015",
    "scope": "classic",
    "color": {
      "hex": "#5E2F26",
      "websafe": "#663333",
      "rgb": {
        "r": 94,
        "g": 47,
        "b": 38
      },
      "hsl": {
        "h": 10,
        "s": 42,
        "l": 26
      },
      "hsb": {
        "h": 10,
        "s": 60,
        "b": 37
      },
      "cmyk": {
        "c": "50",
        "m": "100",
        "y": "100",
        "k": "50"
      }
    },
    "names": {
      "en": "Chestnut brown"
    }
  },
  "8016": {
    "code": "8016",
    "scope": "classic",
    "color": {
      "hex": "#4C2B20",
      "websafe": "#333333",
      "rgb": {
        "r": 76,
        "g": 43,
        "b": 32
      },
      "hsl": {
        "h": 15,
        "s": 41,
        "l": 21
      },
      "hsb": {
        "h": 15,
        "s": 58,
        "b": 30
      },
      "cmyk": {
        "c": "40",
        "m": "80",
        "y": "70",
        "k": "70"
      }
    },
    "names": {
      "en": "Mahogany brown"
    }
  },
  "8017": {
    "code": "8017",
    "scope": "classic",
    "color": {
      "hex": "#442F29",
      "websafe": "#333333",
      "rgb": {
        "r": 68,
        "g": 47,
        "b": 41
      },
      "hsl": {
        "h": 13,
        "s": 25,
        "l": 21
      },
      "hsb": {
        "h": 13,
        "s": 40,
        "b": 27
      },
      "cmyk": {
        "c": "30",
        "m": "70",
        "y": "60",
        "k": "80"
      }
    },
    "names": {
      "en": "Chocolate brown"
    }
  },
  "8019": {
    "code": "8019",
    "scope": "classic",
    "color": {
      "hex": "#3D3635",
      "websafe": "#333333",
      "rgb": {
        "r": 61,
        "g": 54,
        "b": 53
      },
      "hsl": {
        "h": 7,
        "s": 7,
        "l": 22
      },
      "hsb": {
        "h": 7,
        "s": 13,
        "b": 24
      },
      "cmyk": {
        "c": "50",
        "m": "50",
        "y": "40",
        "k": "80"
      }
    },
    "names": {
      "en": "Grey brown"
    }
  },
  "8022": {
    "code": "8022",
    "scope": "classic",
    "color": {
      "hex": "#1A1718",
      "websafe": "#330000",
      "rgb": {
        "r": 26,
        "g": 23,
        "b": 24
      },
      "hsl": {
        "h": 340,
        "s": 6,
        "l": 10
      },
      "hsb": {
        "h": 340,
        "s": 12,
        "b": 10
      },
      "cmyk": {
        "c": "100",
        "m": "50",
        "y": "30",
        "k": "100"
      }
    },
    "names": {
      "en": "Black brown"
    }
  },
  "8023": {
    "code": "8023",
    "scope": "classic",
    "color": {
      "hex": "#A45729",
      "websafe": "#996633",
      "rgb": {
        "r": 164,
        "g": 87,
        "b": 41
      },
      "hsl": {
        "h": 22,
        "s": 60,
        "l": 40
      },
      "hsb": {
        "h": 22,
        "s": 75,
        "b": 64
      },
      "cmyk": {
        "c": "25",
        "m": "75",
        "y": "100",
        "k": "10"
      }
    },
    "names": {
      "en": "Orange brown"
    }
  },
  "8024": {
    "code": "8024",
    "scope": "classic",
    "color": {
      "hex": "#795038",
      "websafe": "#666633",
      "rgb": {
        "r": 121,
        "g": 80,
        "b": 56
      },
      "hsl": {
        "h": 22,
        "s": 37,
        "l": 35
      },
      "hsb": {
        "h": 22,
        "s": 54,
        "b": 47
      },
      "cmyk": {
        "c": "25",
        "m": "60",
        "y": "70",
        "k": "50"
      }
    },
    "names": {
      "en": "Beige brown"
    }
  },
  "8025": {
    "code": "8025",
    "scope": "classic",
    "color": {
      "hex": "#755847",
      "websafe": "#666633",
      "rgb": {
        "r": 117,
        "g": 88,
        "b": 71
      },
      "hsl": {
        "h": 22,
        "s": 24,
        "l": 37
      },
      "hsb": {
        "h": 22,
        "s": 39,
        "b": 46
      },
      "cmyk": {
        "c": "40",
        "m": "60",
        "y": "60",
        "k": "45"
      }
    },
    "names": {
      "en": "Pale brown"
    }
  },
  "8028": {
    "code": "8028",
    "scope": "classic",
    "color": {
      "hex": "#513A2A",
      "websafe": "#663333",
      "rgb": {
        "r": 81,
        "g": 58,
        "b": 42
      },
      "hsl": {
        "h": 25,
        "s": 32,
        "l": 24
      },
      "hsb": {
        "h": 25,
        "s": 48,
        "b": 32
      },
      "cmyk": {
        "c": "60",
        "m": "70",
        "y": "90",
        "k": "60"
      }
    },
    "names": {
      "en": "Terra brown"
    }
  },
  "8029": {
    "code": "8029",
    "scope": "classic",
    "color": {
      "hex": "#7F4031",
      "websafe": "#663333",
      "rgb": {
        "r": 127,
        "g": 64,
        "b": 49
      },
      "hsl": {
        "h": 12,
        "s": 44,
        "l": 35
      },
      "hsb": {
        "h": 12,
        "s": 61,
        "b": 50
      },
      "cmyk": {
        "c": "30",
        "m": "80",
        "y": "80",
        "k": "45"
      }
    },
    "names": {
      "en": "Pearl copper"
    }
  },
  "9001": {
    "code": "9001",
    "scope": "classic",
    "color": {
      "hex": "#E9E0D2",
      "websafe": "#ffcccc",
      "rgb": {
        "r": 233,
        "g": 224,
        "b": 210
      },
      "hsl": {
        "h": 37,
        "s": 34,
        "l": 87
      },
      "hsb": {
        "h": 37,
        "s": 10,
        "b": 91
      },
      "cmyk": {
        "c": "5",
        "m": "5",
        "y": "15",
        "k": "0"
      }
    },
    "names": {
      "en": "Cream"
    }
  },
  "9002": {
    "code": "9002",
    "scope": "classic",
    "color": {
      "hex": "#D7D5CB",
      "websafe": "#cccccc",
      "rgb": {
        "r": 215,
        "g": 213,
        "b": 203
      },
      "hsl": {
        "h": 50,
        "s": 13,
        "l": 82
      },
      "hsb": {
        "h": 50,
        "s": 6,
        "b": 84
      },
      "cmyk": {
        "c": "0",
        "m": "0",
        "y": "10",
        "k": "10"
      }
    },
    "names": {
      "en": "Grey white"
    }
  },
  "9003": {
    "code": "9003",
    "scope": "classic",
    "color": {
      "hex": "#ECECE7",
      "websafe": "#ffffff",
      "rgb": {
        "r": 236,
        "g": 236,
        "b": 231
      },
      "hsl": {
        "h": 60,
        "s": 12,
        "l": 92
      },
      "hsb": {
        "h": 60,
        "s": 2,
        "b": 93
      },
      "cmyk": {
        "c": "0",
        "m": "0",
        "y": "0",
        "k": "0"
      }
    },
    "names": {
      "en": "Signal white"
    }
  },
  "9004": {
    "code": "9004",
    "scope": "classic",
    "color": {
      "hex": "#2B2B2C",
      "websafe": "#333333",
      "rgb": {
        "r": 43,
        "g": 43,
        "b": 44
      },
      "hsl": {
        "h": 240,
        "s": 1,
        "l": 17
      },
      "hsb": {
        "h": 240,
        "s": 2,
        "b": 17
      },
      "cmyk": {
        "c": "35",
        "m": "50",
        "y": "40",
        "k": "90"
      }
    },
    "names": {
      "en": "Signal black"
    }
  },
  "9005": {
    "code": "9005",
    "scope": "classic",
    "color": {
      "hex": "#0E0E10",
      "websafe": "#000000",
      "rgb": {
        "r": 14,
        "g": 14,
        "b": 16
      },
      "hsl": {
        "h": 240,
        "s": 7,
        "l": 6
      },
      "hsb": {
        "h": 240,
        "s": 13,
        "b": 6
      },
      "cmyk": {
        "c": "100",
        "m": "40",
        "y": "50",
        "k": "90"
      }
    },
    "names": {
      "en": "Jet black"
    }
  },
  "9006": {
    "code": "9006",
    "scope": "classic",
    "color": {
      "hex": "#A1A1A0",
      "websafe": "#999999",
      "rgb": {
        "r": 161,
        "g": 161,
        "b": 160
      },
      "hsl": {
        "h": 60,
        "s": 1,
        "l": 63
      },
      "hsb": {
        "h": 60,
        "s": 1,
        "b": 63
      },
      "cmyk": {
        "c": "35",
        "m": "30",
        "y": "30",
        "k": "10"
      }
    },
    "names": {
      "en": "White aluminium"
    }
  },
  "9007": {
    "code": "9007",
    "scope": "classic",
    "color": {
      "hex": "#878581",
      "websafe": "#999999",
      "rgb": {
        "r": 135,
        "g": 133,
        "b": 129
      },
      "hsl": {
        "h": 40,
        "s": 2,
        "l": 52
      },
      "hsb": {
        "h": 40,
        "s": 4,
        "b": 53
      },
      "cmyk": {
        "c": "35",
        "m": "30",
        "y": "30",
        "k": "15"
      }
    },
    "names": {
      "en": "Grey aluminium"
    }
  },
  "9010": {
    "code": "9010",
    "scope": "classic",
    "color": {
      "hex": "#F1ECE1",
      "websafe": "#ffffcc",
      "rgb": {
        "r": 241,
        "g": 236,
        "b": 225
      },
      "hsl": {
        "h": 41,
        "s": 36,
        "l": 91
      },
      "hsb": {
        "h": 41,
        "s": 7,
        "b": 95
      },
      "cmyk": {
        "c": "0",
        "m": "0",
        "y": "5",
        "k": "0"
      }
    },
    "names": {
      "en": "Pure white"
    }
  },
  "9011": {
    "code": "9011",
    "scope": "classic",
    "color": {
      "hex": "#27292B",
      "websafe": "#333333",
      "rgb": {
        "r": 39,
        "g": 41,
        "b": 43
      },
      "hsl": {
        "h": 210,
        "s": 5,
        "l": 16
      },
      "hsb": {
        "h": 210,
        "s": 9,
        "b": 17
      },
      "cmyk": {
        "c": "60",
        "m": "45",
        "y": "30",
        "k": "90"
      }
    },
    "names": {
      "en": "Graphite black"
    }
  },
  "9016": {
    "code": "9016",
    "scope": "classic",
    "color": {
      "hex": "#F1F0EA",
      "websafe": "#ffffff",
      "rgb": {
        "r": 241,
        "g": 240,
        "b": 234
      },
      "hsl": {
        "h": 51,
        "s": 20,
        "l": 93
      },
      "hsb": {
        "h": 51,
        "s": 3,
        "b": 95
      },
      "cmyk": {
        "c": "0",
        "m": "0",
        "y": "5",
        "k": "0"
      }
    },
    "names": {
      "en": "Traffic white"
    }
  },
  "9017": {
    "code": "9017",
    "scope": "classic",
    "color": {
      "hex": "#2A292A",
      "websafe": "#333333",
      "rgb": {
        "r": 42,
        "g": 41,
        "b": 42
      },
      "hsl": {
        "h": 300,
        "s": 1,
        "l": 16
      },
      "hsb": {
        "h": 300,
        "s": 2,
        "b": 16
      },
      "cmyk": {
        "c": "50",
        "m": "30",
        "y": "50",
        "k": "100"
      }
    },
    "names": {
      "en": "Traffic black"
    }
  },
  "9018": {
    "code": "9018",
    "scope": "classic",
    "color": {
      "hex": "#C8CBC4",
      "websafe": "#cccccc",
      "rgb": {
        "r": 200,
        "g": 203,
        "b": 196
      },
      "hsl": {
        "h": 86,
        "s": 6,
        "l": 78
      },
      "hsb": {
        "h": 86,
        "s": 3,
        "b": 80
      },
      "cmyk": {
        "c": "10",
        "m": "5",
        "y": "15",
        "k": "10"
      }
    },
    "names": {
      "en": "Papyrus white"
    }
  },
  "9022": {
    "code": "9022",
    "scope": "classic",
    "color": {
      "hex": "#858583",
      "websafe": "#999999",
      "rgb": {
        "r": 133,
        "g": 133,
        "b": 131
      },
      "hsl": {
        "h": 60,
        "s": 1,
        "l": 52
      },
      "hsb": {
        "h": 60,
        "s": 2,
        "b": 52
      },
      "cmyk": {
        "c": "35",
        "m": "30",
        "y": "30",
        "k": "20"
      }
    },
    "names": {
      "en": "Pearl light grey"
    }
  },
  "9023": {
    "code": "9023",
    "scope": "classic",
    "color": {
      "hex": "#797B7A",
      "websafe": "#666666",
      "rgb": {
        "r": 121,
        "g": 123,
        "b": 122
      },
      "hsl": {
        "h": 150,
        "s": 1,
        "l": 48
      },
      "hsb": {
        "h": 150,
        "s": 2,
        "b": 48
      },
      "cmyk": {
        "c": "15",
        "m": "10",
        "y": "10",
        "k": "50"
      }
    },
    "names": {
      "en": "Pearl dark grey"
    }
  }
}
